/* eslint-disable react/prop-types */
/* eslint-disable no-restricted-syntax */
import React from 'react';
import { connect } from 'react-redux';
import AdCaller from 'helpers/ads/adCaller';
import WithGeo from 'helpers/ads/WithGeo';
import PropTypes from 'prop-types';
import { bindGa, gaWrapper } from 'helpers/analytics';
import Links from 'components/Link';
import InnerHTML from 'components/InnerHTML';
import ErrorBoundary from 'components/ErrorBoundary';
import WithIframeWdt from 'components_v2/common/IFrameWdt/WithIframeWdt';
import IFrameWdt from 'components_v2/common/IFrameWdt';
//import PollWidget from 'components_v2/common/PollWidget';
import _get from 'lodash.get';
import { updateSearchOverlayStatus } from 'routes/articleshow_v2/redux';
import { atfStickyCloseBtnHandler } from 'helpers/ads/utils';
import {
  getURLwithTag,
  getMSPGA,
  convertCDataAnchorTagsForOrganic,
  isOrganicArticle,
  convertCDataAnchorTagsForPaidTraffic,
  getPaidReferrer,
  getAmazonLogoByCountry,
  getKeyword,
  getOnClickWindowFuntion,
} from 'routes/articleshow_v2/utils/mspUtils';
import {
  getSkipAdsFlagForVideo,
  // getBannerData,
  getMsidFromPath,
  // setViewedArticleMsidsInLocalStorage,
  //checkInlineTemplate,
} from 'utils/common';
import ImageV2 from 'components_v2/common/ImageV2';
import {
  // TOI_LIVE_DOMAIN,
  // TOI_DEV_DOMAIN,
  TWITTER_EMBED_SCRIPT,
  IMAGE_URL,
} from 'constants/index.js';
import InfoGraphicMobile from 'components/InfoGraphicMobile/InfoGraphicMobile';
// import WithNativeCampaign from 'helpers/ads/WithNativeCampaign';
// import { ArticleshowWidget } from 'components/Elections2019';
// import LiveblogInsert from 'components/LiveblogInsert';
import WithCommentLoader from 'modules/WithComments/WithCommentLoader';
import CData from 'components_v2/common/CData';
// import WithElectionBannerLoadable from 'components/ElectionBanner/WithElectionBannerLoadable';
// import PrimeScreen from 'components/PrimePaymentFlow/PrimeScreen/PrimeScreen';
// import TimesPointPromoLoader from 'components/TimesPointPromo/TimesPointPromoLoader';
// import LiveblogStickyElection from 'components_v2/common/LiveblogStickyElection';
import ElementInView from 'components_v2/common/ElementInView';
import BackToBrandwire from 'components/BackToBrandwire';
// import LoadableCoronaWidget from 'routes/home/components/common/CoronaHomePageWidget/LoadableCoronaWidget';
import AffiliatesContent from 'components/AffiliatesContent';
import AffiliatesContentV2 from 'components/AffiliatesContentV2';
import AffiliatesProductPanel from 'components_v2/common/AffiliateProductPanel';
import { getEncodedAffiliateLink } from 'utils/Affiliate';
// import ABexperimentWrapper from 'helpers/analytics/ABexperimentWrapper';
// import {
//   updateSearchOverlayPageViewCount,
//   showSearchOverlayPopuponPageView,
// } from 'utils/searchOverlayUtils';
import Accordion from 'components_v2/common/Accordion';
// import TitleBoxSkeleton from 'routes/games/components/common/DailyPuzzles/TitleBoxSkeleton/TitleBoxSkeleton';
/**
 * AmazonNSA is commented because it's not currently in use at Feed-end
 * Uncomment it when required and load it lazily
 */
// import AmazonNSA from '../../components/common/AmazonNativeAds/AmazonNSA';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import InlineCardSlider from 'components_v2/mobile/InlineCardSlider/InlineCardSlider';
// import Cookie from 'utils/cookies';
import Text from '../../components/common/Text';
import Image from '../../components/common/Image';
import LoginAccount from '../../components/common/LoginAccount';
//import VideoWidget from '../../components/common/VideoWidget/VideoWidget';
import Quotes from '../../components/common/Quotes';
import LeadImageOrVideo from '../../components/common/LeadImageOrVideo';
import Byline from '../../components/common/Byline';
import ReadInOtherLanguage from '../../components/common/ReadInOtherLanguage/ReadInOtherLanguage';
import BrandwireComments from '../../components/common/BrandwireComments';
// import ArticleshowBriefs from '../../components/mobile/ArticleshowBriefs/WithArticleshowBriefs';
import Synopsis from '../../components/common/Synopsis/index';
import Keyhighlights from '../../components/common/Keyhighlights/index';
import Mocktale from '../../components/common/Mocktale/Mocktale';
import WithMixedSlider from '../../../home/components/mobile/MixedSlider/MixedSlider';
// import ReadAlsoBottomWidget from '../../components/common/ReadAlsoBottomWidget';
// import SearchWrapper from '../../../../components_v2/mobile/SearchWrapper/SearchWrapper';
import s from './Articleshow_v2.scss';
import linkRelInCrypto from '../../utils/zebpayUtil';
import { getUrlFromactiveSubsection } from '../../../home/components/mobile/PageLayout/utils';
import LinksList from '../../../../components_v2/mobile/LinksList';
// import CoverLayout from '../../../home/components/mobile/CoverLayout';
import LoadableComponentLoader from '../../../../components_v2/common/LoadableComponentLoader/LoadableComponentLoader';
import CalculatorList from '../../../calculator/components/mobile/CalculatorList/CalculatorList';
import ListingStoriesWidget from '../../../../components_v2/mobile/ListingStoriesWidget/ListingStoriesWidget';
import JumpLinksTable from '../../components/common/JumpLinksTable/JumpLinksTable';
import SummarizedStory from '../../components/common/SummarizedStory/SummarizedStory';
import analyticsWrapper from '../../../../helpers/analytics/analyticsWrapper';
import InViewObserver from '../../../../components/InViewObserver/InViewObserver';
import { getGeoCountry } from '../../../../utils/primeUtil';
import PersonaliseWidget from '../../../../components_v2/common/PersonaliseWidget/PersonaliseWidget';
import PersonaliseWidgetWithPoll from '../../../../components_v2/common/PersonaliseWidgetWithPoll/PersonaliseWidgetWithPoll';
import DPLink from '../../../../components_v2/common/Dpanda/DPLink';
import LeadImageWithCaption from '../../components/common/LeadImageWithCaption/LeadImageWithCaption';
import PollWidgetWapper from '../../../../components_v2/common/PollWidget/PollWidgetWapper';
// import ElectionWidgetMainWrapper from '../../../../components/ElectionV2/ElectionWidgetMainWrapper/ElectionWidgetMainWrapper';

function getWebUrl(url) {
  if (typeof window === 'undefined') {
    return url;
  }
  const origin = `${window.location.protocol}//${window.location.hostname}${
    window.location.port ? `:${window.location.port}` : ''
  }`;
  const updatedUrl = url.replace('https://timesofindia.indiatimes.com', origin);
  return updatedUrl;
}

function getInactiveArticleClass({ reason }) {
  // the conditions would need to be uncommented in future if more handling is needed KV
  switch (reason) {
    // case 'INACCURATE':
    //   return 'innaccurate';
    // case 'LEGAL_ISSUES':
    //   return 'legal_issues';
    // case 'Not Applicable':
    //   return 'not_applicable';
    // default:
    //   return 'unavailable';
    default:
      return 'innaccurate';
  }
}

class ArticleshowInner extends React.PureComponent {
  static topStoriesNode;
  constructor(props) {
    super(props);
    this.state = {
      adsPositions: {},
      insertPositions: {},
      // isClientSide: false,
      //textSize: 9,
      showFullArticle: false,
      showTwitterShareArticleContent: false,
      shareOffsetLeft: 0,
      shareOffsetTop: 0,
      shareText: '',
      // #TODO: Make it dynamic after feed integration
      shareLink: '',
      showBackToText: false,
      // isSpotlightArticle: false,
      // isSocialIconsVisible: false,
      isReadMore: false,
      onScrollScripts: new Set(),
      // this flag prevents full Article reading
      // showMrecOnShowFullArticle: false, //Show mrec on click of show full article button
      isReadNextGrxPageViewFired: {},
      viewGA4summarizedstory: false,
      adsRules: null,
    };
    this.articleshowRef = React.createRef();
    this.commentTextInput = React.createRef();
    this.socialIconsRef = React.createRef();
    this.brCount = 0;
    // this.totalBrCount = 0;
    this.getWidgetComponent = {
      cricketscorecard: LoadableComponentLoader,
    };
    this.cardComponent1Rendered = false;
    this.cardComponent2Rendered = false;
    this.wordlength = 0;
    this.articleId = '';
    this.widgetPriorityMap = this.props.widgetPriorityMap;
    this.worldSecrtionMsid = '296589292';
    this.entertainmentSectionMsid = '1081479906';
    this.etimesSectionMsid = '96424146';
    this.etimesFoodSectionMsid = '64732371';
    this.lastScrollTop = 0;
    this.readNextconfigTriggered = false;
    this.personaliseApiTriggered = React.createRef(false);
    this.summarizedstoryGA4Fired = false;
  }
  // refer to https://timesgroup.jira.com/browse/TOIPR-65789
  // setValueSearchOverlayDisplay = () => {
  //   updateSearchOverlayPageViewCount();
  //   if (showSearchOverlayPopuponPageView()) {
  //     sessionStorage.setItem('isSearchOverlayAlreadyShown', 'no');
  //     this.props.updateSearchOverlayStatus(true);
  //   } else {
  //     this.props.updateSearchOverlayStatus(false);
  //   }
  // };

  getSectionName() {
    const sectionName =
      this.props.articleData.navsubsecs &&
      this.props.articleData.navsubsecs.subsec1 &&
      this.props.articleData.navsubsecs.subsec1.subsecname1
        ? this.props.articleData.navsubsecs.subsec1.subsecname1
        : '';

    return sectionName;
  }

  getADRules = () => {
    if (typeof window !== 'undefined' && window._dfpObj?.adsRules) {
      this.setState({ adsRules: window._dfpObj?.adsRules });
    }
  };

  componentDidMount() {
    const {
      articleData,
      // isUserPrime,
      // msid,
      // isWapView,
      // activeMsid,
      loadRelatedArticlesOnPerpetual,
    } = this.props;
    // const grxId = Cookie.get('_grx');
    if (typeof loadRelatedArticlesOnPerpetual === 'function') {
      loadRelatedArticlesOnPerpetual();
    }
    if (this.props.isMspArticle && getPaidReferrer()) {
      convertCDataAnchorTagsForPaidTraffic();
    } else if (this.props.isMspArticle && isOrganicArticle()) {
      convertCDataAnchorTagsForOrganic();
    }
    if (this.isUnavailableArticle()) {
      document.title = 'This article has been removed';
    }
    ArticleshowInner.topStoriesNode =
      ArticleshowInner.topStoriesNode || this.getTopStoriesData();

    // if (typeof window !== 'undefined') {
    //   this.setState({
    //     isClientSide: true,
    //   });
    // }
    this.checkNewsWireArticles();
    if (this.props.isMspArticle) {
      window.mspPlatform = this.mspPlatform;
    }
    // refer to https://timesgroup.jira.com/browse/TOIPR-65789
    // this.setValueSearchOverlayDisplay();
    // if (
    //   this.props.articleData &&
    //   typeof this.props.articleData !== 'undefined' &&
    //   this.props.articleData.wu &&
    //   this.props.articleData.wu.indexOf('/spotlight/') > -1
    // ) {
    //   this.setState({ isSpotlightArticle: true });
    // } else {
    //   this.setState({ isSpotlightArticle: false });
    // }
    this.setOnScrollScripts();
    if (
      articleData &&
      !(articleData.videoss && articleData.videoss.length === 0) &&
      Array.isArray(articleData.images) &&
      articleData.images.length > 1
    ) {
      sendGaThroughProps({
        data: {
          gaCategory: 'WAP-TOI-Articleshow',
          gaAction: 'Swipe - Lead Image Group',
          gaLabel: articleData.images.length,
          nonInteraction: true,
        },
      });
    }
    // Performance related code revert
    // if (this.props.perpetual && grxId) {
    //   const params = {
    //     contentPrimeStatus: 'non-prime',
    //     userPrimeStatus: isUserPrime ? 'prime' : 'non-prime',
    //     msid,
    //     isWapView,
    //     section: this.getSectionName() || '',
    //     subsection: _get(this.props.articleData.navsubsecs, 'subsec2', ''),
    //     activeMsid,
    //   };
    //   this.props.loadpageLevelData(params);
    // }
    this.getADRules();
  }

  // Performance related code revert
  // componentDidUpdate() {
  //   const grxId = Cookie.get('_grx');
  //   if (
  //     !this.props.perpetual &&
  //     grxId &&
  //     !this.personaliseApiTriggered.current
  //   ) {
  //     this.personaliseApiTriggered.current = true;
  //     const { isUserPrime, msid, isWapView, activeMsid } = this.props;
  //     const params = {
  //       contentPrimeStatus: 'non-prime',
  //       userPrimeStatus: isUserPrime ? 'prime' : 'non-prime',
  //       msid,
  //       isWapView,
  //       section: this.getSectionName() || '',
  //       subsection: _get(this.props.articleData?.navsubsecs, 'subsec2', ''),
  //       activeMsid,
  //     };
  //     this.props.loadpageLevelData(params);
  //   }
  // }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleDocumentClickEvent);
  }

  isClassComponent = component =>
    !!(
      typeof component === 'function' &&
      component.prototype &&
      component.prototype.isReactComponent
    );

  checkNewsWireArticles() {
    const { perpetual } = this.props;
    const frmapp = this.props.isAppView;
    try {
      const { referrer } = document;
      if (
        (!perpetual &&
          (referrer &&
            typeof referrer === 'string' &&
            referrer.indexOf('https://www.mediawire.in') !== -1)) ||
        frmapp
      ) {
        this.setState({ showBackToText: true });
      }
    } catch (e) {
      // console.log(e);
    }
  }
  getTopStoriesData() {
    // getting this top stories from layout common object, SEO friendly listing widget.
    const { commonData } = this.props;
    if (
      commonData.data &&
      commonData.data.topStories &&
      commonData.data.topStories.items &&
      commonData.data.topStories.items.length > 0
    ) {
      commonData.data.topStories.data = commonData.data.topStories.items;
      const { data } = commonData.data.topStories;
      for (let counter = 0; counter < data.length; counter += 1) {
        if (typeof data[counter].imageid === 'string') {
          data[counter].image = { id: data[counter].imageid.split('&')[0] };
          data[counter].imageid = '';
        }
      }
    }
    return commonData.data && commonData.data.topStories;
  }
  renderTopStories = () => (
    <React.Fragment>
      {ArticleshowInner.topStoriesNode &&
      ArticleshowInner.topStoriesNode.data &&
      ArticleshowInner.topStoriesNode.data.length > 0 ? (
        <ElementInView gaLabel="top_stories_view">
          <LoadableComponentLoader
            loadInView
            loadableComponentName="ListingWidget"
            item={ArticleshowInner.topStoriesNode}
            imgWidth={100}
            gaPrefix="BTF"
            gaCategory={this.props.categoryForGA}
            gaAction="click"
            gaLabel="top_stories"
          />
        </ElementInView>
      ) : null}
    </React.Fragment>
  );

  getPhotoStoriesWidget = () => {
    const { widgets } = this.props.articleData;

    if (Array.isArray(widgets) && widgets.length) {
      for (let i = 0; i < widgets.length; i += 1) {
        if (widgets[i].tn === 'PhotoStories_widget') {
          return (
            <ElementInView
            // gaAction="view-photostories"
            // gaLabel={subSecSeoLocation}
            >
              <InlineCardSlider
                isHeadingShown
                fromEtimesAS={this.props.isEtimesArticle}
                sectionData={widgets[i]}
                source="AS"
                key="PhotoStories_widget"
                border="top"
                isClientSide
                gaAction="click-photostories"
                layout="horizontal"
                cardSpan={9}
                isCarousel
                cardType="card_21"
                borderTop
              />
            </ElementInView>
          );
        }
      }
    }
    return null;
  };

  getVideosWidget = subSecSeoLocation => {
    const { widgets } = this.props.articleData;
    if (Array.isArray(widgets) && widgets.length) {
      for (let i = 0; i < widgets.length; i += 1) {
        if (widgets[i].tn === 'Videos_widget') {
          return (
            <ElementInView
              gaAction="view-latest-videos"
              gaLabel={subSecSeoLocation}
            >
              <InlineCardSlider
                isHeadingShown
                fromEtimesAS={this.props.isEtimesArticle}
                sectionData={widgets[i]}
                source="AS"
                key="Videos_widget"
                border="top"
                gaAction="click-latest-videos"
                layout="horizontal"
                cardSpan={9}
                isCarousel
                cardType="card_21"
                borderTop
              />
            </ElementInView>
          );
        }
      }
    }
    return null;
  };

  getPopularStories = () => {
    const { widgets } = this.props.articleData;
    if (Array.isArray(widgets) && widgets.length) {
      for (let i = 0; i < widgets.length; i += 1) {
        if (widgets[i].tn === 'NewsList_PopularStories') {
          return (
            <div data-insert="popularfromsection" className="popular_lisiting">
              <ErrorBoundary>
                <ElementInView gaLabel="popular_from_section_view">
                  <LoadableComponentLoader
                    loadOnScroll
                    loadableComponentName="PopularFromSection"
                    moretext={widgets[i].moretext}
                    morelink={widgets[i].morelink}
                    name={widgets[i].name}
                    dataUrl={widgets[i].wu}
                    gaCategory={this.props.categoryForGA}
                    gaAction="click"
                    gaLabel="popular_from_section"
                    className="popular"
                  />
                </ElementInView>
              </ErrorBoundary>
            </div>
          );
        }
      }
    }
    return null;
  };

  getEtimesFeaturedWidget = subSecSeoLocation => {
    const { widgets } = this.props.articleData;

    if (Array.isArray(widgets) && widgets.length) {
      for (let i = 0; i < widgets.length; i += 1) {
        if (widgets[i] && widgets[i].tn === 'Etimes_Featured_Widget') {
          return (
            <ElementInView
              gaAction={
                widgets[i] && widgets[i].gaAction
                  ? `view-${widgets[i].gaAction}`
                  : 'view-featured-in-etimes'
              }
              gaLabel={subSecSeoLocation}
            >
              <InlineCardSlider
                layout="horizontal"
                cardSpan={9}
                isCarousel
                cardType="card_21"
                isHeadingShown
                fromEtimesAS={this.props.isEtimesArticle}
                sectionData={widgets[i]}
                source="AS"
                key="Etimes_Featured_Widget"
                border="top"
                gaAction={
                  widgets[i] && widgets[i].gaAction
                    ? `click-${widgets[i].gaAction}`
                    : 'click-featured-in-etimes'
                }
              />
            </ElementInView>
          );
        }
      }
    }
    return null;
  };

  getEtimesMoreStories = () => {
    const { widgets } = this.props.articleData;
    let subSecSeoLocation =
      _get(this.props.articleData, 'navsubsecs.subsec1.seolocation1') || '';
    const subsecmsid2 =
      _get(this.props.articleData, 'navsubsecs.subsec2.subsecmsid2') || '';
    if (
      this.props.isEtimesArticle &&
      subsecmsid2 &&
      subsecmsid2 === this.etimesFoodSectionMsid
    ) {
      subSecSeoLocation = 'food';
    }
    if (Array.isArray(widgets) && widgets.length) {
      for (let i = 0; i < widgets.length; i += 1) {
        if (widgets[i].tn === 'NewsList_MoreStories') {
          return (
            <div data-insert="morefromsection" className="etimes_more_lisiting">
              <ErrorBoundary>
                <ElementInView
                  gaAction="view-more-from-etimes-news"
                  gaLabel={subSecSeoLocation}
                >
                  <LoadableComponentLoader
                    loadOnScroll
                    loadableComponentName="PopularFromSection"
                    name={widgets[i].name}
                    dataUrl={widgets[i].wu}
                    gaCategory={this.props.categoryForGA}
                    gaAction="click-more-from-etimes-news"
                    className="popular"
                    viewMargin="500px 0px 500px 0px"
                    fromEtimesArticle
                    // theme="more_list"
                  />
                </ElementInView>
              </ErrorBoundary>
            </div>
          );
        }
      }
    }
    return null;
  };

  getTrendingStoriesWidget = () => {
    const { widgets } = this.props.articleData;

    if (Array.isArray(widgets) && widgets.length) {
      for (let i = 0; i < widgets.length; i += 1) {
        if (widgets[i] && widgets[i].tn === 'Featured_Widget') {
          let { items } = widgets[i];
          if (!Array.isArray(items)) {
            return null;
          }
          let listingData;
          if (items.length > 5) {
            const numOfCards = items.length - 3;
            listingData = items.slice(numOfCards);
            items = items.slice(0, numOfCards);
          }
          const sectionData = {
            ...widgets[i],
            items,
          };
          return (
            <ElementInView
              gaLabel={
                sectionData?.secName
                  ? `New_Trending-Stories_In-${sectionData.secName}`
                  : 'New_Trending-Stories_In-TOI'
              }
              gaAction="View"
            >
              <InlineCardSlider
                sectionData={sectionData}
                source="AS"
                key="Featured_Widget"
                gaCategory="mWEB-articleshowv2"
                gaAction="Click"
                gaLabel={
                  sectionData?.secName
                    ? `New_Trending-Stories_In-${sectionData.secName}_Story`
                    : 'New_Trending-Stories_In-TOI_Story'
                }
                layout="horizontal"
                cardSpan={9}
                isCarousel
                cardType="card_21"
                ga4Type={sectionData && sectionData.ga4Type}
              />
              {Array.isArray(listingData) &&
                listingData.length && (
                  <ListingStoriesWidget
                    storiesData={listingData}
                    sectionData={sectionData}
                    cardCount={Array.isArray(items) ? items.length : 0}
                  />
                )}
            </ElementInView>
          );
        }
      }
    }
    return null;
  };
  // getCoronaWidget = () => {
  //   const { widgets } = this.props.articleData;
  //   if (Array.isArray(widgets) && widgets.length) {
  //     for (let i = 0; i < widgets.length; i += 1) {
  //       if (widgets[i].tn === 'NewsList_Corona') {
  //         // return (
  //         //   <div className={s.coronaWidgetWrapper}>
  //         //     <ErrorBoundary>
  //         //       <ElementInView gaAction="View_India Fights Covid">
  //         //         <TileLayout
  //         //           lazyload
  //         //           sectionData={widgets[i]}
  //         //           key={widgets[i].name}
  //         //           leadImageUpperLimit={0}
  //         //           moreLink={widgets[i].path}
  //         //           moreTextVal={widgets[i].moreTextVal}
  //         //         />
  //         //       </ElementInView>
  //         //     </ErrorBoundary>
  //         //   </div>
  //         // );
  //       } else if (widgets[i].tn === 'ipl_tile_pgwdt') {
  //         // Added IPL Photogallery Tile widget at cricket/ipl AS at the place of Corona outbreak widget
  //         return (
  //           <div className={`iplPhotos ${s.coronaWidgetWrapper}`}>
  //             <ErrorBoundary>
  //               <ElementInView gaAction="View_IPL Photos" gaLabel="">
  //                 <div className={s.readAlsoWrapper}>
  //                   <ReadAlsoBottomWidget
  //                     widgetData={widgets[i]}
  //                     widgetClass="mobile"
  //                   />
  //                 </div>
  //               </ElementInView>
  //             </ErrorBoundary>
  //           </div>
  //         );
  //       }
  //     }
  //   }
  //   return null;
  // };
  // eslint-disable-next-line consistent-return
  getMspPageWidgets = () => {
    const { mspWidgets = [] } = this.props.articleData;
    if (mspWidgets.length)
      return mspWidgets.map(widget => {
        if (widget.tn === 'productWidget') {
          if (!this.props.isUserPrime) {
            return (
              <AffiliatesContentV2
                showWidgetOnPrimeToo
                enableWidgetsOnLoad
                {...widget}
              />
            );
          }
          return null;
        }
        return (
          <>
            <div>
              <ErrorBoundary>
                <ElementInView gaAction={`View_${widget.id}`} gaLabel="">
                  <LoadableComponentLoader
                    loadInView
                    loadableComponentName="TileLayout"
                    sectionData={widget}
                    key={widget.name}
                    leadImageUpperLimit={0}
                    moreLink={widget.path}
                    moreTextVal={widget.moreTextVal}
                    className={s.heading_override}
                    useIdForGA
                  />
                </ElementInView>
              </ErrorBoundary>
            </div>
            {widget.name === 'Related Stories' && (
              <div className={s.msp_seperator} />
            )}
          </>
        );
      });
  };

  checkCountOfReadAlsoStory = msid => {
    const articleStory = this.props.articleData && this.props.articleData.story;
    const readAlsoStroyData = articleStory.filter(
      story => story.tn === 'readalso',
    );
    let counter = 0;
    if (readAlsoStroyData instanceof Array && readAlsoStroyData.length > 0) {
      readAlsoStroyData.forEach((data, index) => {
        if (data.contents[0].msid === msid) {
          counter = index + 1;
        }
      });
    }
    return counter;
  };
  handleDocumentClickEvent = () => {
    if (this.state.showTwitterShareArticleContent) {
      this.setState({ showTwitterShareArticleContent: false });
    }
  };
  isUnavailableArticle() {
    // this function returns if the article is taken down article and helps in hiding some items
    if (
      typeof this.props.articleData.status === 'string' &&
      this.props.articleData.status.toLowerCase() === 'unavailable'
    ) {
      return true;
    }
    return false;
  }

  // onSizeChange = currSize => {
  //   this.setState({
  //     textSize: currSize,
  //   });
  // };
  getCommentModerationData() {
    return _get(this.props.articleData, 'metaInfo.CommentModeration', '');
  }

  getMobileStoryAdComponent(data = {}, skipplaceholder) {
    const { lazyMobileBodyAds } = this.props;
    let _immediateLoad = true;
    if (lazyMobileBodyAds && this.props.perpetual) {
      _immediateLoad = false;
    }

    const divwrapper = skipplaceholder ? s.sponser_mid_ad : '';
    const adWapperClass = `${
      s.mobile_ads
    } ${divwrapper} CLSPlaceholder dfp_ATF_wrapper `;
    const adComp = (
      <AdCaller
        pauseAdCall={this.props.blocked !== -1}
        skipReRender
        data={{
          articleIndex: this.props.articleIndex,
          ...data,
        }}
        adWapperClass={adWapperClass}
        msid={this.props.msid}
        deviceType="mobile"
        // immediate load is for very first mrec of page load article
        immediateLoad={_immediateLoad}
      />
    );
    return adComp;
  }

  getInsertsList() {
    const insertArr = [
      'lbinsert',
      'slider',
      'opinion_poll',
      'NewsList_NewsCoverage',
      'NewsList_PopularStories',
      'Amazon_sponsored',
      'related_stories',
    ];
    const widgetsArr = [];
    const finalInsertArr = [];
    const { widgets } = this.props.articleData;
    if (widgets && widgets.length > 0) {
      let counter = 0;
      for (; counter < widgets.length; counter += 1) {
        widgetsArr.push(widgets[counter].tn);
      }

      counter = 0;
      for (; counter < insertArr.length; counter += 1) {
        if (widgetsArr.indexOf(insertArr[counter]) !== -1) {
          finalInsertArr.push(insertArr[counter]);
        }
      }
    }

    return finalInsertArr;
  }

  getPercentageInsertsList = () => {
    let insertPercentageList = {};
    const {
      relatedStoriesInsertPercentage,
      moreEtimesStoriesInsertPercentage,
    } = this.props;

    if (relatedStoriesInsertPercentage) {
      insertPercentageList.related_stories = relatedStoriesInsertPercentage;
    }
    if (moreEtimesStoriesInsertPercentage) {
      insertPercentageList.NewsList_MoreStories = moreEtimesStoriesInsertPercentage;
    }
    insertPercentageList = Object.entries(insertPercentageList)
      .sort(([, a], [, b]) => a - b)
      .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
    return insertPercentageList;
  };
  // showFullArticle = () => {
  //   this.setState({
  //     showFullArticle: true,
  //     showMrecOnShowFullArticle: true,
  //   });
  // };

  @bindGa({})
  // openNICOverlay(event, text) {
  //   const url = event.target.getAttribute('data-href');
  //   const isActive = this.props.isNicOpen && this.props.activeNicUrl === url;
  //   if (isActive) {
  //     //if the clicked nic is active
  //     this.props.toggleNIC(false);
  //   } else if (this.props.isNicOpen) {
  //     //if nic is open then only load the data
  //     this.props.loadNIC(url);
  //     this.props.setNICLabel(text);
  //   } else {
  //     this.props.toggleNIC(true);
  //     this.props.loadNIC(url);
  //     this.props.setNICLabel(text);
  //   }
  // }
  selectText = e => {
    const event = e || window.event;
    const tthis = e.currentTarget;
    const settings = {
      pos: 'right',
      shareBoxWidth: 20,
      minusOffsetTop: 35,
      shortUrl: '',
    };
    let text = null;
    if (window.getSelection) {
      text = window.getSelection().toString();
    } else if (document.selection && document.selection.type !== 'Control') {
      text = document.selection.createRange().text;
    }
    //Remove space
    text = text.replace(/^\s+|\s+$/gm, '');
    if (typeof text === 'string' && text.length > 0) {
      // window.sharetext = text;
      const offsettop =
        event.pageY -
        (window.pageYOffset + tthis.getBoundingClientRect().top) -
        settings.minusOffsetTop;
      let offsetleft =
        parseInt(event.nativeEvent.offsetX, 10) - settings.minusOffsetTop;
      if (settings.pos === 'left') {
        offsetleft = parseInt(tthis.offset().left - settings.shareBoxWidth, 10);
      } else {
        offsetleft =
          parseInt(event.nativeEvent.offsetX, 10) - settings.shareBoxWidth;
      }

      setTimeout(() => {
        this.setState({
          showTwitterShareArticleContent: true,
          shareOffsetLeft: offsetleft,
          shareOffsetTop: offsettop,
          shareText: text.substring(0, 140),
          shareLink: `${this.props.articleData.su} via @${
            this.props.articleData.twtHandle
          }`,
        });
      }, 10);
    }
  };

  shareSelectedText = () => {
    let content = this.state.shareText;
    const link = this.state.shareLink;
    const linkLen = link.length;
    const msgMaxLimit = 133 - linkLen;
    if (content.length > msgMaxLimit) {
      content = `${content.substring(0, 130 - linkLen)}...`;
    }

    window.open(
      `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        content,
      )} - ${link}&original_referer=https://${
        window.location.hostname
      }/share.cms`,
      'socialPost',
      'width=600,height=230,left=383,top=249,scrollbars=0,resizable=false',
    );
  };

  // showPrimeSubscribeNudge = articleshowData => (
  //   <PrimeScreen
  //     componentName="SubscribeNudge"
  //     isWapView
  //     disableBlocker={articleshowData.disableLoginBlocker}
  //   />
  // );

  getSubsectionUrl = () => {
    const { location } = this.props;
    const urlPathParams = location.split('/');
    if (urlPathParams.indexOf('articleshow') > -1) {
      const articleShowIndex = urlPathParams.indexOf('articleshow');
      const subSection = urlPathParams
        .splice(0, articleShowIndex - 1)
        .join('/');
      return subSection;
    }
    return null;
  };

  getHighlightsInsert(data) {
    let highlightedHtml;
    if (data) {
      highlightedHtml = (
        <div className="hltsinsert">
          <React.Fragment>
            {data.title &&
              data.title instanceof Array &&
              data.title.length > 0 && (
                <h5 className={s.highlightedheading}>{data.title[0].value}</h5>
              )}
            {data.items &&
              data.items instanceof Array &&
              data.items.map((val, index) => (
                <div className={s.mosthighlighted}>
                  <span className={s.stamp}>{index + 1}</span>
                  {val.title.length > 0 ? <h3>{val.title}</h3> : ''}
                  <div>
                    {val.value instanceof Array &&
                      val.value.map((valueItem, valueIndex) =>
                        this.getComponents(
                          valueItem,
                          valueIndex,
                          this.props.articleData,
                          '',
                          '',
                          '',
                          true,
                        ),
                      )}
                  </div>
                </div>
              ))}
          </React.Fragment>
        </div>
      );
    }

    return highlightedHtml;
  }

  // getRelatedStoriesWidget = () => {
  //   const domain = __PROD__ ? TOI_LIVE_DOMAIN : TOI_DEV_DOMAIN;

  //   const getRelatedStoriesWidgetData = {
  //     tn: 'list',
  //     theme: 'numbered_list',
  //     id: 'relatedcontentwdt',
  //     name: 'You may also like to read',
  //     dataUrl: `${domain}/feeds/feed_jarvis_list_csr.cms?feedtype=json&tag=relatedcontentwdt&config.perpage=5&count=5&msid=${
  //       this.props.msid
  //     }`,
  //   };
  //   const component = (
  //     <div className={`${s.readAlsoWrapper} ${s.contentReadAlso}`}>
  //       <ReadAlsoBottomWidget
  //         widgetData={getRelatedStoriesWidgetData}
  //         widgetClass="mobile"
  //         isWapView={this.props.isWapView}
  //       />
  //     </div>
  //   );
  //   return component;
  // };

  getMsid = () => {
    if (typeof window !== 'undefined') {
      return getMsidFromPath(window.location.href);
    }

    return '';
  };

  updateAdBasedOn = name => {
    const skipAdsonSecond = ['mgid_second_mrec'];
    const skipPlaceholderArr = ['mgid_second_mrec'];

    const obj = {
      skip: false,
      skipPlaceholder: false,
    };
    if (!name) {
      return obj;
    }
    if (
      this.props.articleIndex === 1 &&
      name &&
      skipAdsonSecond.includes(name)
    ) {
      obj.skip = true;
    }
    if (skipPlaceholderArr.includes(name)) {
      obj.skipPlaceholder = true;
    }

    return obj;
  };

  getSpotlightAllowedAds = (adname, showAds) => {
    if (
      this.props.spotlightSpecificAds &&
      !showAds &&
      !this.props.isUserPrime
    ) {
      const names = ['mrec'];
      if (names.includes(adname)) {
        return true;
      }
    }
    return showAds;
  };

  getAdsInBetweenContent = (data, showAds) => {
    const isDfpAd = data.adsData && data.adsData.adtype !== 'ctn';
    const stickyMrecDfpAdPosArr = [0];
    const { stickyContentSupport } = this.props;
    const key = `custom_ad_${data.pos}_${this.props.articleIndex}`;
    const isMrecSticky =
      stickyMrecDfpAdPosArr.indexOf(data.pos) !== -1 &&
      isDfpAd &&
      stickyContentSupport;
    const showAd = this.getSpotlightAllowedAds(data?.adsData?.name, showAds);

    if (
      showAd &&
      typeof window !== 'undefined' &&
      this.state.adsRules &&
      this.state.adsRules[data.adsData.name] &&
      this.state.adsRules[data.adsData.name].disabled === 1
    ) {
      return null;
    }
    const { skip, skipPlaceholder } = this.updateAdBasedOn(data.adsData.name);
    return (
      showAd &&
      !skip && (
        <>
          <br key={key} />
          <div
            id={`custom_ad_wrapper_${data.pos}`}
            className={`${s.custom_ad_wrapper} ${
              isMrecSticky ? s.with_sticky_wrapper : ''
            }`}
            key={key}
          >
            <div
              id={`custom_ad_${data.pos}`}
              className={`${
                data.adsData && data.adsData.adtype === 'ctn'
                  ? s.custom_ctn_wrapper
                  : s.custom_dfp_wrapper
              } 
                ${isMrecSticky ? s.sticky_elem : ''}`}
            >
              {this.getMobileStoryAdComponent(data.adsData, skipPlaceholder)}
            </div>
          </div>
        </>
      )
    );
  };

  getMrec3AffiliateWidget = data => {
    const subsec1name = _get(
      this.props.articleData,
      'navsubsecs.subsec1.subsecname1',
    );
    const gaLabelPrefix = `${subsec1name}_${this.id}`;
    if (data.pos !== 2) {
      return null;
    }
    return (
      <div className={s.left_right_minus_margin}>
        <AffiliatesContentV2
          type="toi_widget_slots"
          client="affiliates"
          filters={{
            sectionl1: data.sectionl1,
            slot: 'mrec3',
          }}
          componentProps={{
            config: {
              ga: {
                labelPrefix: gaLabelPrefix,
              },
            },
          }}
        />
      </div>
    );
  };

  getInserts(key, articleshowData) {
    const qnaLayout =
      _get(articleshowData, `metaInfo.ToneOfContent`, '').toLowerCase() ===
      'qna';
    if (qnaLayout) return null;
    const { insertPositions } = this.state;
    let component = null;
    if (insertPositions && key && insertPositions[key]) {
      switch (insertPositions[key]) {
        // case 'slider':
        //   component = (
        //     <WithGeo
        //       render={({ geoCountry }) => {
        //         const country =
        //           typeof geoCountry === 'string'
        //             ? geoCountry.toUpperCase()
        //             : '';
        //         if (country === 'IN') {
        //           return <>{this.getAsBriefs()}</>;
        //         }
        //         return null;
        //       }}
        //     />
        //   );
        //   break;
        case 'opinion_poll':
          component = (
            <WithGeo
              render={({ geoCountry }) => {
                const country =
                  typeof geoCountry === 'string'
                    ? geoCountry.toUpperCase()
                    : '';
                if (country === 'IN') {
                  return <>{this.getOpinionPoll()}</>;
                }
                return null;
              }}
            />
          );
          break;
        case 'NewsList_NewsCoverage':
          component = this.getNewsCoverage();
          break;
        // case 'lbinsert':
        //   component = this.getLbInsert();
        //   break;
        case 'NewsList_PopularStories':
          component = this.getPopularStories();
          break;
        case 'NewsList_MoreStories':
          component = this.getEtimesMoreStories();
          break;
        case 'Amazon_sponsored':
          component = this.props.isPromotedAmazonSliderPresent
            ? this.props.getPromotedAmazonSlider(articleshowData)
            : null;
          break;
        // case 'related_stories':
        //   component = !this.props.isMspArticle
        //     ? this.getRelatedStoriesWidget()
        //     : null;
        //   break;
        default:
          component = null;
      }
    }

    return component;
  }
  toggleReadNextGrxViewFired = position => {
    this.setState({
      isReadNextGrxPageViewFired: {
        ...this.state.isReadNextGrxPageViewFired,
        [position]: true,
      },
    });
  };

  checkCountOfVideoWidget = msid => {
    const articleStory = this.props.articleData && this.props.articleData.story;
    const videoWigets = articleStory.filter(
      story => story.tn === 'inlinevideo',
    );
    let counter = 0;
    if (videoWigets instanceof Array && videoWigets.length > 0) {
      videoWigets.forEach((data, index) => {
        if (data.id === msid) {
          counter = index + 1;
        }
      });
    }
    return counter;
  };
  isValidInBetweenContent = () => {
    const { articleData, isMspArticle, isUserPrime, isAdRemoved } = this.props;
    const { ag } = articleData || {};
    return (
      !isUserPrime &&
      !isAdRemoved &&
      !isMspArticle &&
      ag !== 'Mediawire' &&
      ag !== 'SPOTLIGHT' &&
      ag !== 'Brandwire'
    );
  };

  isEducationSection = articleshowData => {
    const sectionId = _get(articleshowData, 'navsubsecs.subsec1.subsecmsid1');
    return sectionId === '93114663';
  };

  isSkipPersonalizationActive = articleshowData => {
    // AF-1130
    const sectionId = _get(articleshowData, 'navsubsecs.subsec1.subsecmsid1');
    const sectionId2 = _get(articleshowData, 'navsubsecs.subsec2.subsecmsid2');
    const skipPersonalizationSecMsid = ['106630271', '67523005'];
    return (
      skipPersonalizationSecMsid.includes(sectionId) ||
      skipPersonalizationSecMsid.includes(sectionId2)
    );
  };

  getComponents(
    data,
    key,
    articleshowData,
    isArticleMini,
    dfp,
    geoAus,
    noads = false,
  ) {
    const skipPersonalizationWidget = this.isSkipPersonalizationActive(
      articleshowData,
    );
    const componentState = this.state;
    // const { componentMounted } = this.state;
    // const { isWapView, electionFlag } = this.props;
    const { isWapView } = this.props;
    let component = '';
    const adComponentPrepend = (
      <React.Fragment>
        {!noads &&
          componentState.adsPositions.length !== 0 &&
          componentState.adsPositions[key] &&
          componentState.adsPositions[key].isPrepend &&
          componentState.adsPositions[key].adComponent}
      </React.Fragment>
    );
    const adComponent = (
      <React.Fragment>
        {!noads &&
          componentState.adsPositions.length !== 0 &&
          componentState.adsPositions[key] &&
          !componentState.adsPositions[key].isPrepend &&
          componentState.adsPositions[key].adComponent}
      </React.Fragment>
    );

    let insertComponent = '';
    const subsec3name = _get(articleshowData, 'navsubsecs.subsec3.subsecname3');
    const subsec4name = _get(articleshowData, 'navsubsecs.subsec4.subsecname4');
    const gaLabel = `${subsec3name ? `${subsec3name}_` : ''}${
      subsec4name ? `${subsec4name}_` : ''
    }${this.id}`;
    const platform = this.props.isAppView ? 'APP' : 'MWEB';
    this.mspPlatform = platform;
    this.mspGaLabel = gaLabel;
    const qnaLayout =
      _get(articleshowData, `metaInfo.ToneOfContent`, '').toLowerCase() ===
      'qna';
    const showAds = !!(
      !this.props.isUserPrime &&
      !this.props.isMspArticle &&
      !this.props.isAdRemoved &&
      !qnaLayout
    );
    const subsecmsid2 = _get(articleshowData, 'navsubsecs.subsec2.subsecmsid2');

    const isAstrologyArticle =
      _get(this.props.articleData, 'navsubsecs.subsec1.subsecmsid1') ===
      '65857041';
    const isReligionArticle =
      _get(articleshowData, 'navsubsecs.subsec1.subsecmsid1') === '79795437';
    const isEducationArticle =
      _get(articleshowData, 'navsubsecs.subsec1.subsecmsid1') === '93114663';
    const isBusinessArticle =
      _get(articleshowData, 'navsubsecs.subsec1.subsecmsid1') === '1898055';

    const isWebSeriesArticle =
      _get(articleshowData, 'navsubsecs.subsec1.subsecmsid1') === '65854450';
    const isEntertainmentArticle =
      _get(articleshowData, 'navsubsecs.subsec1.subsecmsid1') === '1081479906';
    const isLifeStyleArticle =
      _get(articleshowData, 'navsubsecs.subsec1.subsecmsid1') === '2886704';
    const isTVArticle =
      _get(articleshowData, 'navsubsecs.subsec1.subsecmsid1') === '27975577';
    const isEtimesTrendingArticle =
      _get(articleshowData, 'navsubsecs.subsec2.subsecmsid2') === '97575790';

    const isForcePollSection =
      isWebSeriesArticle ||
      isEntertainmentArticle ||
      isLifeStyleArticle ||
      isTVArticle ||
      isEtimesTrendingArticle;

    const isNewListStyleEnabled =
      isAstrologyArticle ||
      isReligionArticle ||
      isEducationArticle ||
      isBusinessArticle;
    const linkRel =
      data.rel || linkRelInCrypto(subsecmsid2, articleshowData.dl);
    if (!noads) {
      insertComponent = (
        <React.Fragment>{this.getInserts(key, articleshowData)}</React.Fragment>
      );
    }
    const { ag: articleAgencyName } = articleshowData;
    const isBrAtFirstIndex =
      _get(this.props.articleData, 'story[0].tn') === 'br';

    if (data.tn) {
      switch (data.tn) {
        case 'iframe': {
          const datad = {
            name: '',
            tn: data.tn,
            dataUrl: data.dataUrl,
            height: data.height,
            id: data.id,
            defaultText: data.defaultText,
            border: data.border,
            key: data.tn,
            useIframeIntersectionObserver: data.useIframeIntersectionObserver,
            ga4Type: data.ga4Type,
            lazy: true,
          };
          component = WithIframeWdt(IFrameWdt, datad);
          break;
        }
        case 'live_cricket_score_card':
          if (!this.props.isEtimesArticle && !this.props.isMspArticle) {
            component = (
              <ErrorBoundary>
                <div className={s.iplWidgetPageWraper}>
                  <LoadableComponentLoader
                    loadInView
                    loadableComponentName="IPLWidgetV2LoaderWrapper"
                    wrapperClass="iplcricketwidget"
                    flipAd={this.isValidInBetweenContent()}
                    msid={this.props.msid}
                    {...data}
                    isStickyCard
                    autoRefresh
                    isWapView
                    gaData="Scorecard_widget|click_mweb|Articleshow"
                    gaViewData={[
                      'Scorecard_widget',
                      'view_mweb',
                      'Articleshow',
                    ]}
                  />
                </div>
              </ErrorBoundary>
            );
          }
          break;
        case 'text':
          component = (
            <React.Fragment>
              {adComponentPrepend}
              <Text
                value={data.value}
                pos={key}
                styleObj={s}
                isWapView={isWapView}
                tags={data.tags}
                forceSpan={this.isUnavailableArticle()}
                jumpLinkId={data.cmsannotationId}
                stpPrpgtnAndPrvDflt
              />
              {insertComponent}
            </React.Fragment>
          );
          break;
        case 'custom_ad': {
          component = (
            <>
              {this.getAdsInBetweenContent(data, showAds)}
              {!this.props.isMspArticle && this.getMrec3AffiliateWidget(data)}
            </>
          );
          break;
        }
        case 'link':
          if (this.props.blocked !== -1) {
            component = (
              <Text
                value={data.value}
                pos={key}
                styleObj={s}
                isWapView={isWapView}
                tags={data.tags}
                forceSpan={this.isUnavailableArticle()}
              />
            );
          } else if (this.props.isMspArticle) {
            const {
              tag,
              wu = '',
              affiliateName,
              notAffiliateLink,
              textElementType = '',
            } = data;
            const linkComponent = (
              <Links
                forceTargetBlank
                rel={data.rel}
                isMspArticle
                ga4Data={[
                  {
                    event: 'user_click',
                    type: 'affiliate_hyperlink',
                    category: 'inline_link',
                    label: notAffiliateLink
                      ? `AS1_${articleshowData.wu}`
                      : `${affiliateName}_${data.value}`,
                  },
                ]}
                to={getURLwithTag(
                  wu,
                  tag,
                  this.props.isOrganic,
                  this.props.isPaidTraffic,
                )}
                target="_blank"
                styleObj={s}
                className={data.tags || ''}
              >
                {data.value}
              </Links>
            );

            component =
              textElementType === 'h5' ? (
                <span className={s.bold_underline}>{linkComponent}</span>
              ) : (
                linkComponent
              );
          } else {
            const checkHtml = /(<([^>]+)>)/i;
            const htmlStatus = checkHtml.test(data.value);
            //const inlineTemplate = checkInlineTemplate(data.wu);
            component = htmlStatus ? (
              <Links
                rel={linkRel}
                to={data.wu}
                styleObj={s}
                className={data.tags || ''}
                skipAffiliateHandling={articleshowData.ag === 'Mediawire'}
                target={data?.target}
                // data-ga={`Click-Hyperlink|${inlineTemplate}-${data.value}-${
                //   data.wu
                // }`}
                dangerouslySetInnerHTML={{
                  __html: `${data.value}`,
                }}
              />
            ) : (
              <Links
                rel={linkRel}
                to={data.wu}
                styleObj={s}
                className={data.tags || ''}
                target={data?.target}
                skipAffiliateHandling={articleshowData.ag === 'Mediawire'}
                // data-ga={`Click-Hyperlink|${inlineTemplate}-${data.value}-${
                //   data.wu
                // }`}
              >
                {data.value}
              </Links>
            );
          }
          break;
        case 'document':
          if (data.type === 'pdf' && data && data.wu) {
            component = (
              <LoadableComponentLoader
                loadOnScroll
                loadableComponentName="PdfEmbed"
                feedPdfCountUrl={data.wu}
                imageUrl={data.imageUrl}
                msid={data.msid}
                title={data.value}
                isWapView
              />
            );
          }
          break;
        case 'keyword':
          if (this.props.blocked !== -1) {
            component = (
              <Text
                value={data.value}
                pos={key}
                styleObj={s}
                isWapView={isWapView}
                tags={data.tags}
                forceSpan={this.isUnavailableArticle()}
              />
            );
          } else {
            component = (
              <Links
                to={data.wu}
                styleObj={s}
                className={data.tags || ''}
                // data-ga={`Click-Hyperlink|link_topic-${data.value}-${data.wu}`}
              >
                {data.value}
              </Links>
            );
          }

          break;
        case 'br':
          this.brCount += 1;
          // if (
          //   this.props.isEtimesArticle &&
          //   this.props.location.includes('/tv') &&
          //   this.brCount === 1 &&
          //   !this.props.isUserPrime
          // ) {
          //   component = (
          //     <>
          //       <br className="id-r-component" data-pos={key} />
          //       <div className="mb8">{leadImageHtml}</div>
          //     </>
          //   );
          // } else {
          if (
            this.brCount === 5 &&
            this.props.isSportsBeaconJs &&
            !this.props.perpetual
          ) {
            component = (
              <>
                <LoadableComponentLoader
                  loadOnScroll
                  loadableComponentName="PixelEmbedVideo"
                  msid={this.props.msid}
                />
              </>
            );
          } else if (
            isLifeStyleArticle &&
            ((!isBrAtFirstIndex && this.brCount === 2) ||
              (isBrAtFirstIndex && this.brCount === 3))
          ) {
            const { articleData: { story = [] } = {} } = this.props;
            const renderCustomPartnerBanner = story.find(
              storyItem => storyItem.tn === 'toi_custom_partner_banner',
            );
            if (!renderCustomPartnerBanner) {
              component = <br />;
              break;
            }
            const sectionl1 = _get(
              articleshowData,
              'navsubsecs.subsec1.subsecnameseo1',
            );
            component = (
              <>
                <br />
                <div id="affilaite_cpb_banner_v2" className={this.brCount}>
                  <AffiliatesContentV2
                    type="toi_custom_partner_banner"
                    client="affiliates"
                    showWidgetOnPrimeToo
                    filters={{
                      pagename: 'articleshow',
                      sectionl1,
                    }}
                    componentProps={{}}
                  />
                </div>
                <br />
              </>
            );
          } else {
            component = (
              <>
                <div className="id-r-component br" data-pos={key} />
                {insertComponent}
              </>
            );
          }
          // }

          break;
        case 'inlineimage':
          component = (
            <>
              <Image
                title={data.title}
                caption={data.cap}
                // url={data.wu}
                altTitle={data.title}
                msid={data.imageId}
                imagesize={data.imagesize}
                overridelink={data.wu}
                styleObj={s}
                key={key}
                target={data.target}
                // placeHolderSrc="https://static.toiimg.com/thumb/imgsize-23456,msid-42706777,width-600,resizemode-4/100128248.jpg"
                skipAffiliateHandling={articleshowData.ag === 'Mediawire'}
                // placeHolderStyles={{maxHeight:}}
              />
              {insertComponent}
            </>
          );
          break;
        case 'inlinevideo': {
          // let slikeId = '';
          // if (data.type === 'slike') {
          //   slikeId = data.playerId;
          // }
          const isVideoSkipAds = getSkipAdsFlagForVideo(
            articleshowData.metaInfo,
          );
          const playerContainerId = `playerContainer_${data.id}_inline`;
          component = (
            <div className={s.inarticlevdo_wrapper}>
              <LoadableComponentLoader
                loadInView
                loadableComponentName="VideoWidget"
                posKey={this.checkCountOfVideoWidget(data.id)}
                video={data}
                styleObj={s}
                isVideoSkipAds={isVideoSkipAds}
                playerContainerId={playerContainerId}
                iconClassName={s.as_playicon}
                imageClassName={`${s.inline_photo} ${s.content}`}
                videoClassName={`${s.content}`}
                isWapView={isWapView}
                isUserPrime={this.props.isUserPrime}
                videoTheatreSliderData={this.props.videoTheatreSliderData}
                addNextVideoMsid={this.props.addNextVideoMsid}
                enableNextVideos
                dataFirstPlayClickGa={`video-inline-user_initiated|msid_${
                  articleshowData.id
                }-video_${data && data.id ? data.id : ''}`}
                dataCloseClickGa={`video-inline-close_video|msid_${
                  articleshowData.id
                }-video_${data && data.id ? data.id : ''}`}
                lazyLoadYoutubeVid
                isInline
                showMiniTvPlayer={this.props.showMiniTvPlayer}
                placeHolderStyles={
                  data?.playerType === 'youtube' || data?.playerType === 'slike'
                    ? { minHeight: '190px' }
                    : null
                }
              />
              {adComponent}
              {insertComponent}
              {/* <div className={s.duration}>{data.du}</div> */}
              <div className={s.inlinevdo_heading}>{data.hl}</div>
              {/* // </div> */}
            </div>
          );
          break;
        }
        case 'cdata': {
          let cdataClassName;
          if (this.props.isMspArticle) {
            cdataClassName = 'modify_cdata_style';
          }
          if (this.props.isEtimesArticle) {
            cdataClassName = 'modify_cdata_style_etimes';
          }
          if (isNewListStyleEnabled) {
            cdataClassName = 'modify_cdata_list_style';
          }

          component = (
            <>
              {adComponentPrepend}
              <CData
                styleObj={s}
                isJumpLinkParent={!!data.cmsannotationId}
                value={data.value}
                type={data.type}
                pos={key}
                disableUnscape={this.props.isMspArticle}
                className={cdataClassName || ''}
                applyLazyLoadLogic
                isMweb
              />
              {adComponent}
              {insertComponent}
            </>
          );
          if (data.tags && data.tags.includes('strong')) {
            component = <strong>{component}</strong>;
          }
          break;
        }
        case 'inlineaudio': {
          component = data.playerType === 'slike' && (
            <LoadableComponentLoader
              loadOnScroll
              loadableComponentName="Podcast"
              msid={data.id}
              slikeId={data.playerId}
              duration={data.du}
              hl={data.hl}
              //autoplay
              isVideoSkipAds
              store={this.context.store}
              isPrime={this.props.isPrime}
              //asyncLoadSdkjs
              isWapView={this.props.isWapView}
            />
          );
          break;
        }
        case 'sub':
          component = <sub>{data.value}</sub>;
          break;
        case 'wimbledoniframe':
          component = WithIframeWdt(IFrameWdt, {
            ...data,
            key: data.id || data.name || data.tn,
            className: s[data.theme || 'inlineIframe'],
            wu:
              'https://2022.wimbledon.com/en_GB/syndicated/thetimesofindia/index.html',
            height: 268,
            id: 'wimbledoniframe',
          });
          break;
        case 'sup':
          component = <sup>{data.value}</sup>;
          break;
        case 'quote':
          component = <Quotes styleObj={s} {...data} />;
          break;
        case 'extquote':
          component = <Quotes styleObj={s} {...data} />;
          break;
        case 'also_published':
          component = <div className={s.alsoPublished}>{data.value}</div>;
          break;
        case 'slideshow':
          component = (
            <LoadableComponentLoader
              {...data}
              isWapView={isWapView}
              // title={this.props.articleData.hl}
              wu={getWebUrl(this.props.articleData.wu)}
              query={this.props.query}
              loadInView
              loadableComponentName="Slideshow"
              placeHolderStyles={{ minHeight: '400px' }}
            />
          );
          break;
        case 'readalso':
          if (
            !skipPersonalizationWidget &&
            !this.isEducationSection(articleshowData)
          ) {
            component = (
              <InViewObserver
                inViewCallback={() => {
                  if (!this.state.viewGA4summarizedstory) {
                    analyticsWrapper('ga4', {
                      event: 'user_shown',
                      type: 'top_pick_for_you',
                    });
                  }
                }}
              >
                <PersonaliseWidget
                  isWapView
                  card="readAlso"
                  section={this.getSectionName() || ''}
                  subsection={_get(
                    this.props.articleData?.navsubsecs?.subsec2,
                    'subsecname2',
                    '',
                  )}
                  msid={this.props.msid}
                  template="AS"
                  contentprimestatus="non-prime"
                  userprimestatus={
                    this.props.isUserPrime ? 'prime' : 'non-prime'
                  }
                  styleObj={{ minHeight: '316px' }}
                  classname="readalsoshimmer"
                  disableWidget={this.props.isMspArticle}
                  ga4Type="top_pick_for_you"
                />
              </InViewObserver>
            );
          }
          break;
        case 'banner_insert':
          if (!(data.imageUrl || data.bannerImageMsid)) {
            return null;
          }

          component = (
            <InViewObserver
              inViewCallback={() => {
                analyticsWrapper('ga4', {
                  event: 'user_shown',
                  type: data.ga4Type,
                  category: data.ga4Category,
                });
              }}
              className={s.bannerInsert}
            >
              <Links
                target="_blank"
                to={data.wu}
                onClick={() => {
                  analyticsWrapper('ga4', {
                    event: 'user_click',
                    type: data.ga4Type,
                    category: data.ga4Category,
                  });
                }}
              >
                <ImageV2
                  src={
                    data.imageUrl ||
                    `${IMAGE_URL}/photo/${data.bannerImageMsid}.cms`
                  }
                  alt="Banner Insert"
                  lazyload
                />
              </Links>
            </InViewObserver>
          );
          break;
        case 'pollwidget':
          // perosnalize widget with poll to be removed along with pollwidget
          if (
            isForcePollSection &&
            this.props.forcePollShow &&
            this.props.forcePollShow === '1' &&
            !this.props.isMspArticle &&
            articleAgencyName !== 'Mediawire' &&
            articleAgencyName !== 'SPOTLIGHT' &&
            articleAgencyName !== 'Brandwire' &&
            data &&
            data.categorytabs !== 'No Poll'
          ) {
            component = (
              <PollWidgetWapper
                dataUrl={data.dataUrl}
                key={`${data.tn}_${key}`}
                isLoggedIn={this.props.isUserLoggedin}
                toggleLoginBox={this.props.showLogin}
                ga4Type={data?.ga4Type}
                ga4Category={data?.ga4Category}
                height="326px"
                hideShareFeature
                sectionName={this.props?.sectionName}
              />
            );
          } else if (
            data.embedStories &&
            data.embedStories &&
            Array.isArray(data.embedStories) &&
            data.embedStories.length > 0
          ) {
            component = (
              <PersonaliseWidgetWithPoll
                card="readAlso"
                msid={this.props.msid}
                template="AS"
                contentprimestatus="non-prime"
                userprimestatus={this.props.isUserPrime ? 'prime' : 'non-prime'}
                styleObj={{ minHeight: '330.06px' }}
                classname="readalsoshimmer"
                disableWidget={this.props.isMspArticle}
                stories={data.embedStories}
              />
            );
          } else if (
            !this.props.isMspArticle &&
            articleAgencyName !== 'Mediawire' &&
            articleAgencyName !== 'SPOTLIGHT' &&
            articleAgencyName !== 'Brandwire' &&
            data &&
            (!data.embedStories || data.embedStories === '') &&
            data.categorytabs !== 'No Poll'
          ) {
            component = (
              <PollWidgetWapper
                dataUrl={data.dataUrl}
                key={`${data.tn}_${key}`}
                isLoggedIn={this.props.isUserLoggedin}
                toggleLoginBox={this.props.showLogin}
                ga4Type={data?.ga4Type}
                ga4Category={data?.ga4Category}
                height="326px"
                hideShareFeature
                sectionName={this.props?.sectionName}
              />
            );
          }
          break;
        case 'summarizedstory':
          if (!this.summarizedstoryGA4Fired) {
            analyticsWrapper('ga4', {
              event: 'component_load',
              type: 'articleshow_extended_related_stories',
            });
            this.summarizedstoryGA4Fired = true;
          }
          component = (
            <InViewObserver
              inViewCallback={() => {
                if (!this.state.viewGA4summarizedstory) {
                  analyticsWrapper('ga4', {
                    event: 'user_shown',
                    type: 'articleshow_extended_related_stories',
                  });
                  this.setState({ viewGA4summarizedstory: true });
                }
              }}
              className={s.summarizedStory}
            >
              <SummarizedStory
                value={data.value}
                su={data.su}
                syn={data.syn}
                msid={data.msid}
              />
            </InViewObserver>
          );
          break;
        case 'poll':
          break;
        case 'widget': {
          if (data.type === 'inline_videos_slider') {
            component = (
              <InlineCardSlider
                sectionData={{ ...data }}
                isWapView={isWapView}
                keyId={key}
                layout="horizontal"
                cardSpan={8}
                isCarousel
                cardType="card_20"
                wrapperClass="videos_insert"
                isInsert
                ga4Type={data && data.ga4Type}
              />
            );
          }
          const Widget = this.getWidgetComponent[data.type];
          if (Widget) {
            if (data.type === 'cricketscorecard') {
              component = (
                <Widget
                  {...data}
                  isWapView={isWapView}
                  keyId={key}
                  loadInView
                  loadableComponentName="CricketScorecard"
                />
              );
            } else {
              component = (
                <Widget {...data} isWapView={isWapView} keyId={key} />
              );
            }
          }
          break;
        }
        // case 'exitpolltable': {
        //   if (
        //     this.props.exitPollData &&
        //     this.props.exitPollData.items &&
        //     this.props.exitPollData.items.length
        //   ) {
        //     component = (
        //       <ArticleshowWidget
        //         exitPollData={this.props.exitPollData}
        //         exitPoll
        //       />
        //     );
        //   }

        //   break;
        // }
        // case 'resulttable': {
        //   if (
        //     this.props.electionsData &&
        //     this.props.electionsData.items &&
        //     this.props.electionsData.items.srcdata &&
        //     this.props.electionsData.items.srcdata.length
        //   ) {
        //     component = (
        //       <ArticleshowWidget electionsData={this.props.electionsData} />
        //     );
        //   }
        //   break;
        // }
        case 'openinappbanner':
          if (_get(articleshowData, `ads.ctn.slots.NativePrime.slotId`)) {
            component = (
              <AdCaller
                pauseAdCall={this.props.blocked !== -1}
                className={`${s.mobile_ads} ${s.nohide}`}
                data={{
                  adCode: _get(
                    articleshowData,
                    `ads.ctn.slots.NativePrime.slotId`,
                  ),
                  msid: articleshowData.id,
                  name: 'openinappbanner',
                }}
                isCTN
              />
            );
          } else {
            component = null;
          }

          break;
        case 'inlineAd': {
          const adObject = _get(articleshowData, data.ref, {});
          const newAdObject = {
            ...adObject,
            articleIndex: this.props.articleIndex,
            divId: `${adObject.divId}-${articleshowData.id}`,
            name: 'inlineAd',
          };
          component = (
            <AdCaller
              pauseAdCall={this.props.blocked !== -1}
              className={s.mobile_ads_spacing}
              deviceType="mobile"
              data={newAdObject}
            />
          );
          break;
        }
        case 'timeline': {
          // if (data.type === 'hltsinsert') {
          component = this.getHighlightsInsert(data);
          // }
          break;
        }
        // TODO: Election Widget
        // case 'electionwdt': {
        //   return (
        //     <ErrorBoundary>
        //       <InViewObserver
        //         inViewCallback={() => {
        //           analyticsWrapper('ga4', {
        //             event: 'user_shown',
        //             type: `exitpoll_widget`,
        //           });
        //         }}
        //       >
        //         <div className={s.asElectionWidgetWrap}>
        //           <ElectionWidgetMainWrapper
        //             isWapView={this.props.isWapView}
        //             isPowerByAd={this.props.isPowerByAd}
        //             isPowerByAdActive={this.props.isPowerByAdActive}
        //             tabs={this.props?.electionTabs}
        //             hideStarCandidate
        //             hideLiveblog
        //             hideHeading
        //             hideSharing
        //             hideTitle
        //             hideInfocus
        //             hideDisplayText
        //             hidePowerStates
        //             isInnerWidget
        //             hideETheading
        //             electionwdtWap
        //           />
        //         </div>
        //       </InViewObserver>
        //     </ErrorBoundary>
        //   );
        // }
        // case 'ipl_mid_article':
        //   component = this.props.isIPLMidArticleWidgetPresent
        //     ? this.props.getIPLMidArticleWidgets(articleshowData)
        //     : '';
        //   break;
        case 'affiliate_product_panel': {
          const { affiliateName, index, title, sectionl1 = '' } = data;
          const {
            navsubsecs: { subsec3: { subsecnameseo3 } = {} } = {},
          } = this.props.articleData;

          if (this.props.isUserPrime) {
            component = null;
          } else {
            component = (
              <AffiliatesProductPanel
                isMobile
                handleOrganic
                isPaidTraffic={this.props.isPaidTraffic}
                isMspUSPage={this.props.isMspUSPage ? 'us' : ''}
                data={data}
                keyword={_get(
                  articleshowData,
                  'metaInfo.Amazonaffiliatesproduct',
                )}
                isAppView={this.props.isAppView}
                componentProps={{
                  config: {
                    affiliateName,
                    useGA4: true,
                    ga4: {
                      type: 'affiliate_widget',
                      category: 'inarticle',
                      story_no: index,
                      subsection: sectionl1,
                      subsection2: subsecnameseo3,
                      label: `${affiliateName}_${title}`,
                      // subsection2: subsec3name,
                    },
                  },
                  data: {
                    withHeading: title,
                  },
                }}
              />
            );
          }
          break;
        }
        case 'affiliate_product_inlineImage': {
          if (this.props.isUserPrime) {
            component = null;
          } else {
            const {
              navsubsecs: { subsec3: { subsecnameseo3 = '' } = {} } = {},
            } = this.props.articleData;
            const {
              data: { affiliatename, imageURL = '', url = '' } = {},
              linkTag,
              widgetTag,
              index,
              title,
              sectionl1 = '',
            } = data;
            let widgetUrl = getURLwithTag(
              url,
              widgetTag,
              this.props.isOrganic,
              this.props.isPaidTraffic,
            );
            const dataGA = getMSPGA(platform, gaLabel, affiliatename, 'object');
            if (url) {
              widgetUrl = getEncodedAffiliateLink('', widgetUrl, true, true);
            }
            const logoURLObj =
              affiliatename === 'amazon'
                ? { logoURL: getAmazonLogoByCountry() }
                : {};
            component = widgetUrl ? (
              <>
                {data.isNewArticle && (
                  <Links
                    forceTargetBlank
                    rel={data.rel}
                    to={getURLwithTag(
                      url,
                      linkTag,
                      this.props.isOrganic,
                      this.props.isPaidTraffic,
                    )}
                    isMspArticle
                    target="_blank"
                    data-ga={`${dataGA.category}|${dataGA.action +
                      (index ? `_${index}` : '')}|${dataGA.label}${
                      data.title ? `_${data.title}` : ''
                    }`}
                  >
                    <h2 className={s.aff_subheading}>{data.title}</h2>
                  </Links>
                )}
                <div data-msp_product_id={url}>
                  <AffiliatesContent
                    enableWidgetsOnLoad
                    type={`product_widget_inline_image${
                      this.props.isMspUSPage ? '_us' : ''
                    }`}
                    handlePaidTraffic
                    filters={{
                      pagename: 'articleshow',
                      affiliateName: affiliatename,
                    }}
                    componentProps={{
                      config: {
                        useGA4: true,
                        affiliateName: 'amazon',
                        ga4: {
                          type: 'affiliate_widget',
                          category: 'inarticle',
                          story_no: index,
                          subsection: sectionl1,
                          subsection2: subsecnameseo3,
                          label: `${affiliatename || 'amazon'}_${title}`,
                        },
                      },
                      data: {
                        ...data.data,
                        url: widgetUrl,
                        ...logoURLObj,
                      },
                    }}
                  />
                </div>
              </>
            ) : (
              <Image
                title={data.title}
                url={imageURL}
                altTitle={data.title}
                styleObj={s}
              />
            );
          }
          break;
        }
        case 'affiliate_multi_product_panel_inline_image': {
          if (this.props.isUserPrime) {
            component = null;
          } else {
            component = (
              <AffiliatesProductPanel
                data={data}
                isAppView={this.props.isAppView}
                isPaidTraffic={this.props.isPaidTraffic}
                handleOrganic
                isMspUSPage={this.props.isMspUSPage}
                componentProps={{
                  config: {
                    affiliateName: data.affiliateName,
                    useGA4: true,
                    ga4: {
                      type: 'affiliate_widget',
                      category: 'inarticle',
                      // subsection2: subsec3name,
                    },
                  },
                  data: {
                    ga: {
                      label: `${subsec3name}_${subsec4name}_${this.id}${
                        data.title ? `_${data.title}` : ''
                      }`,
                    },
                  },
                }}
              />
            );
          }
          break;
        }
        case 'astro_talk_widget': {
          if (isAstrologyArticle) {
            component = (
              <AffiliatesContentV2
                type="toi_widget_slots"
                client="affiliates"
                filters={{
                  pagename: 'articleshow',
                  slot: 'body_insert',
                  sectionl1: 'Astrology',
                  keywords: 'astro_talk',
                }}
                componentProps={{
                  config: {
                    ga: {
                      label: this.props.msid,
                    },
                  },
                }}
              />
            );
          }
          break;
        }
        case 'custom_partner_banner': {
          component = (
            <AffiliatesContentV2
              type="msp_custom_partner_banner"
              client="affiliates"
              showWidgetOnPrimeToo
              filters={{
                sectionl1: data.sectionl1,
                sectionl2: subsec4name,
              }}
              componentProps={{
                data: {
                  ga: {
                    label: `Inbody_${gaLabel}`,
                  },
                },
              }}
            />
          );
          break;
        }
        case 'jumpLinksTable': {
          component = <JumpLinksTable data={data} isWap />;
          break;
        }
        case 'dpanda_inline_link': {
          const { needLeftSpace = false, data: dpData = {} } = data || {};
          component = <DPLink {...{ needLeftSpace }} data={dpData} />;
          break;
        }

        default:
          component = '';
      }

      // if (key === this.state.briefPosition && componentMounted) {
      //   component = [component, this.getAsBriefs()];
      // }
    }
    return [component];
  }

  renderFactsheetLayout(story, articleshowData) {
    let headline = [];
    let accContent = [];
    const leadImageText = [];
    const finalHtml = [];
    let inlinecontent = [];
    let headlineIndex = 0;
    for (let i = 0; i < story.length; i += 1) {
      if (headlineIndex && story[i].value?.indexOf('<h2>') > -1) {
        finalHtml.push({
          headline,
          content: accContent,
          nonaccContent: inlinecontent,
        });
        headline = [];
        accContent = [];
        inlinecontent = [];
      }
      if (story[i].tn === 'cdata' && story[i].value?.indexOf('<h2>') > -1) {
        headline.push(this.getComponents(story[i], i, articleshowData));
        headlineIndex += 1;
      } else if (
        (story[i].tn === 'cdata' && story[i].value?.indexOf('<h6>') > -1) ||
        inlinecontent?.length
      ) {
        inlinecontent.push(this.getComponents(story[i], i, articleshowData));
      } else if (headlineIndex) {
        accContent.push(this.getComponents(story[i], i, articleshowData));
      } else {
        leadImageText.push(this.getComponents(story[i], i, articleshowData));
      }
      if (i === story.length - 1) {
        finalHtml.push({
          headline,
          content: accContent,
          nonaccContent: inlinecontent,
        });
      }
    }
    let renderAccordion = finalHtml.length > 0;
    if (
      renderAccordion &&
      finalHtml.length === 1 &&
      finalHtml[0].headline.length === 0 &&
      finalHtml[0].content.length === 0 &&
      finalHtml[0].nonaccContent.length === 0
    ) {
      renderAccordion = false;
    }
    return (
      <div className={s.qnaLayout}>
        {leadImageText}
        {renderAccordion && (
          <>
            <div className={s.accGuide}>
              <img
                className={s.infoIcon}
                src="https://static.toiimg.com/photo/93323395.cms"
                alt=""
              />
              Tap to expand and read more
            </div>
            <Accordion
              data={finalHtml}
              onChange={() => {
                gaWrapper(
                  'send',
                  'event',
                  'factsheet',
                  'accordian_click',
                  this.props.msid,
                );
              }}
              isMweb
            />
          </>
        )}
      </div>
    );
  }
  getHouzzHtml = () => {
    const { articleData } = this.props;
    let validInnerHtml = true;
    if (articleData && articleData.widgets) {
      const { widgets } = articleData;
      for (let i = 0; i < widgets.length; i += 1) {
        if (widgets[i].tn === 'Houzz') {
          if (widgets[i].geo) {
            const { currentCountry } = this.props;
            const geoArr = widgets[i].geo.split('|');
            if (!currentCountry || geoArr.indexOf(currentCountry) === -1) {
              validInnerHtml = false;
            }
          }

          if (validInnerHtml) {
            return <InnerHTML data={{ ...widgets[i] }} />;
          }

          break;
        }
      }
    }

    return null;
  };

  // downloadTOIAppHtml(articleData) {
  //   if (this.isUnavailableArticle()) {
  //     return null;
  //   }
  //   const newsVal =
  //     this.props.articleData.bc &&
  //     this.props.articleData.bc[0] &&
  //     this.props.articleData.bc[0].value !== 'News'
  //       ? this.props.articleData.bc[0].value
  //       : '';
  //   return (
  //     <div
  //       className={s.downloadapp}
  //       data-scrollga={`OpenAppBanner#scroll#${(articleData &&
  //         articleData.wu) ||
  //         ''}`}
  //     >
  //       Download The Times of India{' '}
  //       <Links
  //         target="_blank"
  //         to="https://timesofindia.onelink.me/efRt/5c80760d"
  //         data-ga={`OpenAppBanner|click|${(articleData && articleData.wu) ||
  //           ''}`}
  //       >
  //         <strong>News App</strong>
  //       </Links>{' '}
  //       for Latest{' '}
  //       <Links
  //         target="_blank"
  //         to="https://timesofindia.onelink.me/efRt/5c80760d"
  //         data-ga={`OpenAppBanner|click|${(articleData && articleData.wu) ||
  //           ''}`}
  //       >
  //         <strong>
  //           {newsVal}{' '}
  //           {newsVal.length <= 4 ||
  //           (newsVal.length > 4 &&
  //             newsVal.substr(newsVal.length - 4, 4).toLowerCase() !== 'news')
  //             ? 'News'
  //             : 'News updates'}
  //         </strong>
  //       </Links>
  //       .
  //     </div>
  //   );
  // }

  openSidebar = () => {};

  checkLocation = () => {
    let { currentCountry } = this.props;
    // const country = ['IN', 'US', 'UAE', 'CA'];
    const country = ['IN'];
    if (
      typeof window !== 'undefined' &&
      window.geoinfo &&
      window.geoinfo.CountryCode
    ) {
      currentCountry = window.geoinfo.CountryCode;
    }
    if (country.indexOf(currentCountry) !== -1) return true;
    return false;
  };

  getNewsCoverage = () => {
    const { widgets } = this.props.articleData;
    if (Array.isArray(widgets) && widgets.length) {
      for (let i = 0; i < widgets.length; i += 1) {
        if (widgets[i].tn === 'NewsList_NewsCoverage') {
          return (
            <>
              <LoadableComponentLoader
                loadInView
                loadableComponentName="NewsCoverage"
                isWapView={this.props.isWapView}
                dataUrl={widgets[i].wu}
              />;
            </>
          );
        }
      }
    }
    return null;
  };

  // getLbInsert = () => {
  //   const { widgets } = this.props.articleData;
  //   let component = null;
  //   if (widgets) {
  //     for (let i = 0; i < widgets.length; i += 1) {
  //       if (widgets[i].tn === 'lbinsert') {
  //         if (this.props.perpetual && !this.props.isWapView) {
  //           component = (
  //             <LazyLoad offsetVertical={500} debounce={false}>
  //               <LiveblogInsert
  //                 data={widgets[i]}
  //                 isWapView
  //                 theme="asv2insert"
  //               />
  //             </LazyLoad>
  //           );
  //         } else {
  //           component = (
  //             <LiveblogInsert data={widgets[i]} isWapView theme="asv2insert" />
  //           );
  //         }

  //         break;
  //       }
  //     }
  //   }
  //   return component;
  // };

  getOpinionPoll = () => {
    const { widgets } = this.props.articleData;
    let returnHtml = null;
    if (Array.isArray(widgets) && widgets.length) {
      for (let i = 0; i < widgets.length; i += 1) {
        if (widgets[i].tn === 'opinion_poll') {
          returnHtml = (
            <LoadableComponentLoader
              loadInView
              loadableComponentName="PollWidget"
              dataUrl={widgets[i].wu}
              hideShareFeature
              key={widgets[i].tn}
              isLoggedIn={this.props.isUserLoggedin}
              toggleLoginBox={this.props.showLogin}
              isElectionPoll
              isExternalClass={s.Electionpollwidget}
            />
          );
        }
      }
    }
    return returnHtml;
  };

  // getGamesData = () => (
  //   <ElementInView
  //     gaCategory="gameswidget_spas"
  //     gaLabel="mweb"
  //     gaAction="view_widget"
  //   >
  //     <LoadableComponentLoader
  //       loadOnScroll
  //       loadableComponentName="DailyPuzzles"
  //       fallbackComponent={<TitleBoxSkeleton />}
  //       gamesToShow={['crossword', 'sudoku']}
  //       title="PLAY EXCITING PUZZLES & GAMES"
  //       gaMetaData={{ EC: 'gameswidget_spas' }}
  //       deviceType="mweb"
  //       iconImageIdMap={{
  //         cw: 88709998,
  //         sudoku: 88710081,
  //         ws: 88710085,
  //         wf: 88710095,
  //       }}
  //       isWidget
  //       gamesEntryWidget
  //     />
  //   </ElementInView>
  // );

  // getAsBriefs = () => {
  //   // const articleshowData = this.props.articleData;
  //   // const { widgets } = articleshowData;
  //   if (this.props.blocked !== -1) {
  //     return null;
  //   }

  //   const subsec2 = _get(
  //     this.props.articleData.navsubsecs,
  //     'subsec2',
  //     undefined,
  //   );
  //   if (
  //     subsec2 &&
  //     typeof subsec2 === 'object' &&
  //     typeof subsec2.subsecmsid2 !== 'undefined' &&
  //     subsec2.subsecmsid2 === '82453999'
  //   ) {
  //     // Removing news in briefs if article is from crypto currenmcy
  //     return null;
  //   }

  //   let returnHtml = null;
  //   const sectionName =
  //     this.props.articleData.navsubsecs &&
  //     this.props.articleData.navsubsecs.subsec1 &&
  //     this.props.articleData.navsubsecs.subsec1.subsecname1
  //       ? this.props.articleData.navsubsecs.subsec1.subsecname1
  //       : '';

  //   let asBriefsData;
  //   if (this.props.asBriefsData) {
  //     if (this.props.isUserPrime && this.props.asBriefsData.items) {
  //       // remove ad first.
  //       asBriefsData = this.props.asBriefsData.items.filter(
  //         item => typeof item.adCode === 'undefined',
  //       );
  //       this.props.asBriefsData.items = asBriefsData;
  //     }
  //   }
  //   returnHtml = this.props.asBriefsData && (
  //     <ElementInView gaLabel="Briefs_view">
  //       <ArticleshowBriefs
  //         asSectionName={sectionName}
  //         asBriefsData={this.props.asBriefsData}
  //         isWapView={this.props.isWapView}
  //         isUserPrime
  //         gaCategory={this.props.categoryForGA}
  //         gaAction="click"
  //         gaLabel="Briefs_"
  //       />
  //     </ElementInView>
  //   );
  //   return returnHtml;
  // };
  renderOldStoryMsg = oldStoryText => {
    const msg = typeof oldStoryText === 'string' ? oldStoryText.trim() : '';

    return msg.length ? oldStoryText : '';
  };

  isIPhone = () => navigator.userAgent.toLowerCase().indexOf('iphone') >= 0;

  showTimesClubFun = data => {
    // const { geo: { location } = {} } = data || {};
    // const { currentCountry } = this.props;
    // if (location instanceof Array && currentCountry && this.isIPhone()) {
    //   return location.filter(country => country === currentCountry).length;
    // }

    if (data.slotId && this.isIPhone()) {
      return true;
    }
    return false;
  };

  getInlineMedia = (
    contentVisibility,
    data,
    country,
    itemIndex,
    isLead,
    gaAction,
    sectionId,
    gaLabelPrefix,
    gaLabelSuffix,
  ) => {
    const { InlineVideos } = this.props;

    if (!this.isClassComponent(InlineVideos)) {
      return null;
    }
    // use InlineCardSlider if being turned on somewhere
    return (
      <InlineVideos
        sectionData={data}
        key={data.tn}
        theme={data.theme}
        autoPlayLeadVideo={data.autoplay === '1'}
        gaAction={gaAction}
        source="INNHP"
        useContentVisibilty={contentVisibility}
        gaLabelPrefix={gaLabelPrefix}
        gaLabelSuffix={gaLabelSuffix}
        useImageV2
        openVideoLink
      />
    );
  };

  getTopVideosWidget = () => {
    const { CoverLayout } = this.props;

    const { widgets } = this.props.articleData;
    if (
      !this.isClassComponent(CoverLayout) ||
      !widgets ||
      !Array.isArray(widgets)
    ) {
      return null;
    }
    const topVideosWidget = widgets.find(widget => widget.id === 'topvideos');
    if (!topVideosWidget) {
      return null;
    }
    const typeComponentMapping = {
      videoslider: this.getInlineMedia.bind(
        this,
        this.props.useContentVisibilty,
      ),
      photoslider: this.getInlineMedia.bind(
        this,
        this.props.useContentVisibilty,
      ),
    };
    const index = 1;
    const mappedComponent = (
      <ElementInView
        gaCategory={this.props.categoryForGA}
        gaAction="View"
        gaLabel="TOP_Videos"
        className="articleShowTopVideos"
      >
        <CoverLayout
          sectionData={topVideosWidget}
          listingHeader
          isTOPVideosSlider
          key={topVideosWidget.name}
          id={`${topVideosWidget.tn}_${index}`}
          loadAjaxSectionData={this.props.loadAjaxSectionData}
          typeComponentMapping={typeComponentMapping}
          index={index}
          leadImageUpperLimit={0}
          moreLink={getUrlFromactiveSubsection(topVideosWidget)}
          geolocation={this.props.geolocation}
          gaCategory={this.props.categoryForGA}
          gaAction="Click"
          tabChangeGaAction="Click"
          tabChangeGaLabel="Click_TOP_Videos_tab"
          gaLabelPrefix="Click_TOP_Videos_Playlist"
          defaultTabName="LATEST"
          hideMoreBtn={
            !!(
              typeof topVideosWidget.hideMoreBtn !== 'undefined' &&
              topVideosWidget.hideMoreBtn === 'yes'
            )
          }
          useLightBGMoreBtn
        />
      </ElementInView>
    );
    return mappedComponent;
  };

  // getReadAlsoWidget = () => {
  //   const { articleIndex } = this.props;
  //   const { widgets } = this.props.articleData;
  //   let myComp = null;
  //   if (widgets && Array.isArray(widgets)) {
  //     for (let i = 0; i < widgets.length; i += 1) {
  //       if (
  //         typeof widgets[i] !== 'undefined' &&
  //         typeof widgets[i].id !== 'undefined' &&
  //         this.widgetPriorityMap &&
  //         (this.widgetPriorityMap.storieswidget &&
  //           this.widgetPriorityMap.storieswidget[widgets[i].id] &&
  //           this.widgetPriorityMap.storieswidget[widgets[i].id] === '1') &&
  //         (this.widgetPriorityMap.storieswidgetpg === '' ||
  //           (this.widgetPriorityMap.storieswidgetpg &&
  //             Array.isArray(this.widgetPriorityMap.storieswidgetpg) &&
  //             (this.widgetPriorityMap.storieswidgetpg === 0 ||
  //               this.widgetPriorityMap.storieswidgetpg.includes(
  //                 articleIndex + 1,
  //               ))) ||
  //           (articleIndex + 1 >= 5 &&
  //             this.widgetPriorityMap.storieswidgetpg &&
  //             Array.isArray(this.widgetPriorityMap.storieswidgetpg) &&
  //             (this.widgetPriorityMap.storieswidgetpg === 0 ||
  //               this.widgetPriorityMap.storieswidgetpg.includes(1))))
  //       ) {
  //         if (
  //           widgets[i].id === 'related_stories_widt_v2' ||
  //           widgets[i].id === 'ibeatmostreadarticles'
  //         )
  //           myComp = (
  //             <div className={s.readAlsoWrapper}>
  //               <ReadAlsoBottomWidget
  //                 widgetData={widgets[i]}
  //                 widgetClass="mobile"
  //                 isWapView={this.props.isWapView}
  //               />
  //             </div>
  //           );
  //       }
  //     }
  //   }
  //   return myComp;
  // };

  // getReadAlsoInlineWidget = widgetname => {
  //   const { widgets } = this.props.articleData;
  //   let myComp = null;
  //   if (widgets && Array.isArray(widgets)) {
  //     for (let i = 0; i < widgets.length; i += 1) {
  //       if (
  //         typeof widgets[i] !== 'undefined' &&
  //         typeof widgets[i].id !== 'undefined' &&
  //         (widgets[i].id === 'trendingstorycity' ||
  //           widgets[i].id === 'trendingstoryentire') &&
  //         widgets[i].id === widgetname
  //       ) {
  //         const data = {
  //           readAlsoData: widgets[i].items,
  //           theme: widgets[i].theme,
  //           name: widgets[i].name,
  //           id: widgets[i].id,
  //           gaName: widgets[i].gaName,
  //         };
  //         myComp = (
  //           <ReadAlsoBottomWidget
  //             widgetData={data}
  //             readAlsoData={widgets[i].items}
  //             widgetClass="mobile"
  //             isWapView={this.props.isWapView}
  //           />
  //         );
  //       }
  //     }
  //   }
  //   return myComp;
  // };

  getAffilateWidget = () => {
    const articleshowData = this.props.articleData;
    const { isMspArticle, isEtimesArticle } = this.props;
    const {
      ag: articleAgencyName,
      affKeyword,
      navsubsecs: {
        subsec1: { seolocation1: subsecnameseo1 } = {},
        subsec2: { subsecnameseo2 } = {},
      } = {},
    } = articleshowData;

    // const isWorldArticle =
    //   _get(articleshowData, 'navsubsecs.subsec1.subsecmsid1') === '296589292';
    const isCryptoCurrencyArticle =
      _get(articleshowData, 'navsubsecs.subsec2.subsecmsid2') === '82453999';
    // const isCityArticle =
    //   _get(articleshowData, 'navsubsecs.subsec1.subsecmsid1') === '-2128932452';

    // removeAffiliateWidget can be used from feed to remove affiliate widget from all AS-v2.
    if (
      !isEtimesArticle &&
      !isMspArticle &&
      !this.isAffilateWidgetRendered &&
      articleAgencyName !== 'Mediawire' &&
      articleAgencyName !== 'SPOTLIGHT' &&
      articleAgencyName !== 'Brandwire' &&
      // !isWorldArticle &&
      // !isCityArticle &&
      !isCryptoCurrencyArticle
    ) {
      this.isAffilateWidgetRendered = true;
      return (
        <AffiliatesContentV2
          type="toi_widget_slots"
          className={s.aff_articleshow}
          client="affiliates"
          componentProps={{
            config: {
              // affiliateName,
              ga4: {
                section: subsecnameseo1,
                subsection: subsecnameseo2,
              },
            },
          }}
          filters={{
            pagename: 'articleshow',
            keyword: affKeyword,
            // slot: 'body_insert',
            sectionl1: subsecnameseo1,
          }}
        />
      );
    }
    return null;
  };

  getVisualStories = () => {
    const articleshowData = this.props.articleData;
    if (
      articleshowData &&
      articleshowData.visualStories &&
      Array.isArray(articleshowData.visualStories.items) &&
      articleshowData.visualStories.items.length
    ) {
      return (
        <ErrorBoundary>
          <ElementInView
            // gaAction={
            //   this.props.isEtimesArticle
            //     ? 'view-visual-stories'
            //     : 'scroll_measure'
            // }
            // gaLabel={
            //   this.props.isEtimesArticle
            //     ? subSecSeoLocation
            //     : 'visualstories_view'
            // }
            className="articleshowVs"
          >
            <WithMixedSlider
              sectionData={{
                name: articleshowData.visualStories.title,
                path: articleshowData.visualStories.path,
                items: articleshowData.visualStories.items,
                feedclass: articleshowData.visualStories.feedclass,
              }}
              theme={articleshowData.visualStories.theme}
              clickGaAction={
                this.props.isEtimesArticle
                  ? 'click-visual-stories'
                  : 'click_visualstory'
              }
              isClickableHeader
              lazyloadImg
            />
          </ElementInView>
        </ErrorBoundary>
      );
    }
    return null;
  };

  setOnScrollScripts() {
    const articleStory = this.props.articleData && this.props.articleData.story;
    let cdataScrollScripts = new Set();
    const cdataItems =
      articleStory && Array.isArray(articleStory)
        ? articleStory.filter(story => story.tn === 'cdata')
        : [];
    cdataItems.forEach(item => {
      if (item?.type?.toLowerCase() === 'twitter') {
        cdataScrollScripts.add(TWITTER_EMBED_SCRIPT);
      } else if (item.scripts) {
        cdataScrollScripts = new Set([...cdataScrollScripts, ...item.scripts]);
      }
    });
    this.setState({
      onScrollScripts: cdataScrollScripts,
    });
  }

  // checkIfClickedOutsideSharedIcons = e => {
  //   const { isSocialIconsVisible } = this.state;
  //   if (
  //     isSocialIconsVisible &&
  //     this.socialIconsRef.current &&
  //     !this.socialIconsRef.current.contains(e.target)
  //   ) {
  //     this.setState({ isSocialIconsVisible: false });
  //     document.removeEventListener(
  //       'mousedown',
  //       this.checkIfClickedOutsideSharedIcons,
  //     );
  //   }
  // };

  // showSocialSharedicons = () => {
  //   this.setState({ isSocialIconsVisible: true });
  //   document.addEventListener(
  //     'mousedown',
  //     this.checkIfClickedOutsideSharedIcons,
  //   );
  // };

  getAffiliateWidgetCarousel = () => {
    const {
      story: articleStory = [],
      navsubsecs: { subsec3: { subsecnameseo3 = '' } = {} } = {},
    } = this.props.articleData;
    const affWidgetCarouselData = articleStory.find(
      (item = {}) => item.tn === 'affiliates_product_carousel',
    );
    const {
      type,
      affiliateName,
      sectionl1,
      productid,
      productListMsid,
      shouldRender,
    } =
      affWidgetCarouselData || {};
    const windowFunctions = [];
    if (sectionl1 && type !== 'hp_bulleted_carousel') {
      windowFunctions.push(
        getOnClickWindowFuntion('dfpPush', [
          'ua:click',
          `${affiliateName || 'amazon'}-affiliate-${sectionl1}`,
        ]),
      );
    }

    return (
      shouldRender && (
        <AffiliatesContent
          enableWidgetsOnLoad
          type={`${type}${this.props.isMspUSPage ? '_us' : ''}`}
          handleOrganic
          handlePaidTraffic
          inViewClass="aff_sticky_widget"
          minHeight="350px"
          affiliateCountry={this.props.isMspUSPage ? 'us' : ''}
          componentProps={{
            config: {
              useGA4: true,
              affiliateName: 'amazon',
              ga4: {
                type: 'affiliate_widget',
                category: 'carousel',
                subsection: sectionl1,
                subsection2: subsecnameseo3,
                story_no: '',
                config: { windowFunctions },
              },
            },
          }}
          filters={{
            pagename: 'articleshow',
            affiliateName,
            sectionl1,
            productid,
            productListMsid,
            keyword: getKeyword(),
          }}
        />
      )
    );
  };
  aboutAuthorWidget = () => {
    let authorComponent = null;
    const {
      getAuthorWidgetDetails: {
        description,
        facebook: fb,
        twitter,
        image,
      } = {},
    } =
      this.props.articleData || {};
    const imgSrc = image
      ? `https://timesofindia.indiatimes.com/authorphoto/${image}.cms`
      : 'https://static.toiimg.com/photo/63379366.cms';
    if (description) {
      const url = {
        fb,
        twitter,
      };
      authorComponent = (
        <div className={s.about_author} id="auhtor_widget">
          <div className={s.author_details}>
            <div className={s.author_social}>
              <div className={s.author}>
                <h5>About the Author</h5>
                <Links
                  to={
                    this.props?.articleData?.getAuthorWidgetDetails
                      ?.authorPageLink
                  }
                  className={s.author_name}
                >
                  {this.props?.articleData?.getAuthorWidgetDetails?.name}
                </Links>
              </div>
              <div className={s.author_imge}>
                <Image url={imgSrc} altTitle="author" styleObj={s} />
              </div>
            </div>

            <div
              className={`${s.author_desc} ${
                !this.state.isReadMore ? s.readmorelineclamping : ''
              }`}
            >
              <p>
                {this.props?.articleData?.getAuthorWidgetDetails?.description}
                {this.props?.articleData?.getAuthorWidgetDetails?.description
                  ?.length > 180 && (
                  <button
                    className={s.readmore}
                    onClick={() => {
                      const divContentElem = document.getElementById(
                        'auhtor_widget',
                      );
                      this.setState(
                        { isReadMore: !this.state.isReadMore },
                        () => {
                          if (divContentElem && !this.state.isReadMore) {
                            divContentElem.scrollIntoView({
                              block: 'center',
                              behavior: 'smooth',
                            });
                          }
                        },
                      );
                    }}
                  >
                    {!this.state.isReadMore ? `Read More` : `Show Less`}
                  </button>
                )}
              </p>
            </div>
            {(url?.fb || url?.twitter) && (
              <div className={s.followus_box}>
                <span>Follow On</span>
                <LoadableComponentLoader
                  loadableComponentName="SocialSharingMobile"
                  url={url}
                  isTablet={false}
                  // gaCategory={categoryForGA}
                  gaAction="click"
                  gaIndex="atfShare_"
                  textRequired={false}
                  hideemail
                  isAuthorWidget
                  hidesharingdot
                  hideFollowUsNative
                />
              </div>
            )}
          </div>
        </div>
      );
    }
    return authorComponent;
  };
  getBottomBanner = (story = []) => {
    const bannerData = story.find((item = {}) => item.tn === 'bottomBanner');
    if (bannerData) {
      const {
        href,
        dataURL,
        ga: { action = '', label = '' } = {},
        imgSrc,
        dataPlugin,
      } = bannerData;

      return (
        <ElementInView
          className={s.msp_banner}
          gaAction={action.replace('Click', 'View')}
        >
          <Links
            target="_blank"
            href={href}
            data-plugin={dataPlugin}
            rel="nofollow sponsored noreferrer"
            data-url={dataURL}
            onClick={() => {
              sendGaThroughProps({
                data: {
                  gaCategory: this.props.categoryForGA,
                  gaAction: action,
                  gaLabel: label,
                },
              });
            }}
          >
            <Image url={imgSrc} altTitle="msp affiliate banner" styleObj={s} />
          </Links>
        </ElementInView>
      );
    }
    return '';
  };

  render() {
    this.brCount = 0;
    // this.totalBrCount = 0;
    this.cardComponent1Rendered = false;
    this.cardComponent2Rendered = false;
    this.isAffilateWidgetRendered = false;
    const commentModerationVal = this.getCommentModerationData();
    const articleshowData = this.props.articleData;
    const isHotPicks =
      _get(articleshowData, 'navsubsecs.subsec1.subsecmsid1') === '106630271';
    const {
      msid,
      categoryForGA,
      // clientSideJpodCard,
      isMspArticle,
      articleIndex,
      sectionName,
      isAdRemoved,
      preloadedLeadImageHref,
      AffiliatePageIframe,
    } = this.props;
    const { showBackToText } = this.state;
    // const { exitIntentPopup } = this.props;
    const exitIntentPopup = '';
    // const ImageElement = ImageV2;
    //const topStoriesNode = commonData.data && commonData.data.topStories;
    const {
      story,
      ads,
      // widgets,
      ag,
    } = articleshowData;
    const mspBottomBanner = isMspArticle && this.getBottomBanner(story);
    const subsecname3 = _get(articleshowData, 'navsubsecs.subsec3.subsecname3');
    const subsecname4 = _get(articleshowData, 'navsubsecs.subsec4.subsecname4');

    const mspSectionName = `${subsecname3 || ''}${
      subsecname4 ? `_${subsecname4}` : ''
    }`;

    // const { ctn, dfp, amazonNsaAd } = ads || {};
    const { dfp } = ads || {};
    // const adbeforeLeadImage = _get(dfp, 'slots.MREC', null);
    const isWillowMetaPresent =
      _get(articleshowData, `metaInfo.SpecialID`, '') === 'willow';
    //#TODO: improve logic for articleshow mini
    const isArticleMini = this.props.isMiniView && !this.state.showFullArticle;
    //const toggleMiniClass = isArticleMini ? s.miniclamp : '';
    // const wdtData =
    //   widgets && widgets instanceof Array && widgets.length > 0
    //     ? getBannerData(widgets)
    //     : undefined;
    // const breadCrumbString =
    //   this.props.articleData.bc instanceof Array
    //     ? this.props.articleData.bc
    //         .map(
    //           item =>
    //             typeof item.value === 'string'
    //               ? item.value.toLowerCase().replace(' ', '_')
    //               : '',
    //         )
    //         .join('_')
    //     : '';
    this.id = articleshowData.id;
    const frmapp = this.props.isAppView;
    let leadImageHtml;
    const isCityArticle =
      _get(articleshowData, 'navsubsecs.subsec1.subsecmsid1') === '-2128932452';

    const isSynopsisPresent =
      articleshowData.syn && articleshowData.syn.length > 0;

    const isHighlighPresent =
      (articleshowData.hlts && articleshowData.hlts.length > 0) ||
      (articleshowData.hltsCdata && articleshowData.hltsCdata.length > 0);

    const isExplainerArticle =
      _get(articleshowData, `metaInfo.NatureOfContent`, '').toLowerCase() ===
      'explainer';
    const isAstrologyArticle =
      _get(this.props.articleData, 'navsubsecs.subsec1.subsecmsid1') ===
      '65857041';
    const isReligionArticle =
      _get(this.props.articleData, 'navsubsecs.subsec1.subsecmsid1') ===
      '79795437';
    const sectionl1 = _get(
      this.props.articleData,
      'navsubsecs.subsec1.subsecnameseo1',
    );
    // const isBusinessArticle =
    //   _get(articleshowData, 'navsubsecs.subsec1.subsecmsid1') === '1898055';
    // const isReligionArticle =
    //   _get(articleshowData, 'navsubsecs.subsec1.subsecmsid1') === '79795437';
    // const isEducationArticle =
    //   _get(articleshowData, 'navsubsecs.subsec1.subsecmsid1') === '93114663';

    const isSynopsisEnabled = ag !== 'SPOTLIGHT';
    const isPerPectualArticle = this.props.parentMsid !== this.props.msid;
    // AF-526
    const keyword100 = _get(articleshowData, 'seo.keyword100');
    const firstKeyword =
      _get(articleshowData, 'seo.keywords', '').split(',')[0] || undefined;
    const imageAlt = isMspArticle ? keyword100 || firstKeyword : undefined;
    const qnaLayout =
      _get(articleshowData, `metaInfo.ToneOfContent`, '').toLowerCase() ===
      'qna';

    if (
      this.props.blocked === -1 &&
      articleshowData.videos &&
      articleshowData.videos.length > 0
    ) {
      leadImageHtml = (
        <LeadImageOrVideo
          hl={articleshowData.hl}
          artilceMsid={articleshowData.id}
          video={articleshowData.videos[0]}
          videoImageId={
            articleshowData.imageid && articleshowData.imageid.length
              ? articleshowData.imageid.split('&')[0]
              : ''
          }
          highlight={articleshowData.hlts}
          highlightCdata={articleshowData.hltsCdata}
          styleObj={s}
          isWapView={this.props.isWapView}
          isUserPrime={this.props.isUserPrime}
          videoCaption={
            articleshowData.images && articleshowData.images[0]
              ? articleshowData.images[0].cap
              : ''
          }
          loadVideoTheatreSlider={this.props.loadVideoTheatreSlider}
          videoTheatreSliderData={this.props.videoTheatreSliderData}
          addNextVideoMsid={this.props.addNextVideoMsid}
          isArticleshow
          cb={this.props.stickyAppCb}
          bottom={350}
          isExplainerArticle={isExplainerArticle}
          activeMsid={this.props.activeMsid}
          isPerpetual={this.props.perpetual}
          enableDocking={this.props.enableDocking}
          enableAutoPlay={this.props.enableAutoPlay}
          isAutoPublishedArticle={this.props.isAutoPublishedArticle}
        />
      );
    } else if (articleshowData.images && articleshowData.images.length > 0) {
      const resizemode = this.props.isAutoPublishedArticle ? 72 : 4;
      const height = this.props.isAutoPublishedArticle ? 'height-225' : '';
      leadImageHtml = (
        <div
          className={s.leadImageWrap}
          data-ua-type="1"
          data-sp-pd-click="stpPgtnAndPrvntDefault(event)"
          onClick={event => {
            window.stpPgtnAndPrvntDefault(event);
          }}
        >
          <LeadImageWithCaption
            hl={articleshowData.hl}
            preloadedLeadImageHref={preloadedLeadImageHref}
            image={articleshowData.images[0]}
            imageAlt={imageAlt}
            isArticleshow
            syn={isMspArticle ? '' : articleshowData.syn}
            resizemode={resizemode}
            isMspArticle={isMspArticle}
            height={height}
          />
        </div>
      );
    } else if (articleshowData.images && articleshowData.images.length > 1) {
      const { images } = articleshowData;
      leadImageHtml = (
        <LeadImageOrVideo
          hl={articleshowData.hl}
          imgList={images}
          highlight={articleshowData.hlts}
          isWapView={this.props.isWapView}
          highlightCdata={articleshowData.hltsCdata}
          isUserPrime={this.props.isUserPrime}
          styleObj={s}
          isArticleshow
          className={
            this.isUnavailableArticle()
              ? getInactiveArticleClass({
                  reason: articleshowData.reason,
                })
              : ''
          }
          cb={this.props.stickyAppCb}
          bottom={350}
          isExplainerArticle={isExplainerArticle}
          isMspArticle={isMspArticle}
          syn={articleshowData.syn}
          activeMsid={this.props.activeMsid}
          isPerpetual={this.props.perpetual}
          isAutoPublishedArticle={this.props.isAutoPublishedArticle}
        />
      );
    }

    //esi - this is not stable from feeds end, reverting back to ctn
    // let esiHtmlSnippet;
    // if (
    //   esi &&
    //   esi.top &&
    //   esi.bottom &&
    //   esi.adSlots &&
    //   esi.adSlots.AROUND_THE_WEB
    // ) {
    //   esiHtmlSnippet = {
    //     __html: esi.top + esi.adSlots.AROUND_THE_WEB + esi.bottom,
    //   };
    // }
    // if (story && story.length > 0) {
    //   story.forEach(item => {
    //     if (item.tn === 'br') {
    //       this.totalBrCount += 1;
    //     }
    //   });
    // }
    const atfAdObj = _get(articleshowData, `ads.dfp.slots.ATF`, {});

    const isEntertainmentArticle =
      _get(this.props.articleData, 'navsubsecs.subsec1.subsecmsid1') ===
        this.entertainmentSectionMsid || false;
    // const isEtimesSectionArticle =
    //   _get(this.props.articleData, 'navsubsecs.subsec1.subsecmsid1') ===
    //     this.etimesSectionMsid || false;

    let subSecSeoLocation =
      _get(this.props.articleData, 'navsubsecs.subsec1.seolocation1') || '';

    const subsecmsid2 =
      _get(this.props.articleData, 'navsubsecs.subsec2.subsecmsid2') || '';
    if (
      this.props.isEtimesArticle &&
      subsecmsid2 &&
      subsecmsid2 === this.etimesFoodSectionMsid
    ) {
      subSecSeoLocation = 'food';
    }
    const isThisArticleAdActive = this.isValidInBetweenContent();
    return (
      <>
        {/* {this.showPrimeSubscribeNudge(articleshowData)} */}
        {this.props.parentMsid !== this.props.msid &&
          story &&
          story.length > 0 && (
            <div className={`${s.separator} clearfix`}>
              <i />
              <span>Up Next</span>
            </div>
          )}
        {isPerPectualArticle &&
          (!this.props.isUserPrime &&
            !isMspArticle &&
            !isAdRemoved &&
            atfAdObj.adCode && (
              <>
                <div data-sticky-close={`atf_${this.props.msid}`} />
                <div
                  className="ATF_wrapper_perpetual"
                  data-sticky-id={`atf_${this.props.msid}`}
                >
                  <AdCaller
                    deviceType="mobile"
                    skipReRender
                    data={{
                      name: 'atf',
                      articleIndex: this.props.articleIndex,
                      ...atfAdObj,
                      divId: `${atfAdObj.divId}-atf-${msid}`,
                    }}
                    className={s.mobile_ads_spacing}
                  />
                  <button
                    className="close-ad"
                    onClick={atfStickyCloseBtnHandler}
                  />
                </div>
              </>
            ))}
        <div
          className={`${s.main_ASwrapper} dark_capsul`}
          ref={this.articleshowRef}
          data-font={this.props.textSize}
          data-mspSectionName={mspSectionName}
          data-articlemsid={this.props.msid}
          data-sticky-target={
            isPerPectualArticle ? `atf_${this.props.msid}` : 'atf'
          }
        >
          {articleshowData.oldStoryText &&
            !isMspArticle && (
              <div className={s.oldarticle_tag}>
                {this.renderOldStoryMsg(articleshowData.oldStoryText)}
              </div>
            )}

          <div className={s.articleHead}>
            {/* <div className={s.articleHead_top}> */}
            {/* {articleshowData.bc && articleshowData.bc.length ? (
                <Links
                  className={s.breadcrumb}
                  to={articleshowData.bc[0].wu || articleshowData.bc[0].su}
                  rel="noopener"
                  data-ga={`ATF_section_tag|${
                    articleshowData.bc[0].value
                  }|label`}
                  data-setgacategory
                >
                  {articleshowData.bc[0].value}
                </Links>
              ) : null} */}

            {/* <a href="https://" className={s.personalisebtn}>ß
                Personalise
              </a> */}
            {/* </div> */}
            {showBackToText &&
              articleshowData &&
              articleshowData.advertorial &&
              articleshowData.advertorial.backToAgencyText &&
              articleshowData.advertorial.sponsoredUrl && (
                <div className={s.backto_brandwire}>
                  <BackToBrandwire
                    sponsoredUrl={articleshowData.advertorial.sponsoredUrl}
                    agency={articleshowData.ag}
                    backToAgencyText={
                      articleshowData.advertorial.backToAgencyText
                    }
                  />
                </div>
              )}
            <h1
              data-ua-type="1"
              data-sp-pd-click="stpPgtnAndPrvntDefault(event)"
              onClick={event => {
                window.stpPgtnAndPrvntDefault(event);
              }}
              className={`${s.articleHeading} ${
                showBackToText ? s.shiftduetobackto : ''
              }`}
              dangerouslySetInnerHTML={{ __html: articleshowData.hl }}
            />

            {articleshowData.ag === 'Brandwire' &&
            articleshowData.advertorial &&
            articleshowData.advertorial.sponsoredText ? (
              <div className={s.brandwire_sponsored_txt}>
                {articleshowData.advertorial.sponsoredText}
              </div>
            ) : null}
            <div className={s.articleAuthor_wrapper}>
              <div className={s.articleAuthorShare_wrapper}>
                <Byline
                  ag={articleshowData.ag || ''}
                  guestName={articleshowData.guestName || ''}
                  dl={articleshowData.dl || ''}
                  dlStr={articleshowData.dlStr || ''}
                  updStr={articleshowData.updStr || ''}
                  upd={articleshowData.upd}
                  author={articleshowData.authors}
                  removeTime={this.props.isMspUSPage}
                  isWapView={this.props.isWapView}
                  sClassName="byline"
                />
                {/* {!this.isUnavailableArticle() &&
                  !isMspArticle &&
                  !this.props.isAppView && (
                    <div className={`${s.shareButton} mob-share-button`}>
                      <span
                        onClick={this.showSocialSharedicons}
                        className={s.shareIcon}
                      />
                      {isSocialIconsVisible && (
                        <div
                          className={`${s.tpSpacing}`}
                          ref={this.socialIconsRef}
                        >
                          <LoadableComponentLoader
                            loadOnClick
                            loadableComponentName="SocialSharingMobile"
                            msid={articleshowData.id}
                            // isParent={articleshowData.id === this.props.parentMsid}
                            url={articleshowData.su || articleshowData.wu}
                            title={articleshowData.hl}
                            isWapView
                            image={
                              articleshowData.images
                                ? articleshowData.images[0]
                                : undefined
                            }
                            openSidebar={this.openSidebar}
                            commentsCount={
                              this.props.blocked === -1
                                ? this.props.commentsCount
                                : 0
                            }
                            wu={articleshowData.wu}
                            via={articleshowData.via}
                            isTablet={false}
                            commentModeration={commentModerationVal}
                            whatsAppShow
                            wrapperClass="mobile-socialshare-top"
                            gaCategory={categoryForGA}
                            gaAction="click"
                            gaIndex="atfShare_"
                            headerCrownPoints={this.props.headerCrownPoints}
                            tpShow
                            type="atf"
                            toggleSocialSharedIcons={() =>
                              this.setState({ isSocialIconsVisible: false })
                            }
                            sectionName={sectionName.toLowerCase()}
                            isEtimes={this.props.isEtimesArticle}
                          />
                        </div>
                      )}
                    </div>
                  )} */}
              </div>
              {articleshowData.readInOthLang && (
                <ReadInOtherLanguage langData={articleshowData.readInOthLang} />
              )}
            </div>
          </div>

          {leadImageHtml}

          {isSynopsisPresent &&
            isSynopsisEnabled &&
            !isCityArticle && (
              <Synopsis
                synopsis={articleshowData.syn}
                customClass="mweb-articleshow"
              />
            )}
          <div className="as_socialsharimgmobile mob-share-button">
            <LoadableComponentLoader
              loadableComponentName="SocialSharingMobile"
              msid={articleshowData.id}
              isParent={false}
              // isParent={articleshowData.id === this.props.parentMsid}
              url={articleshowData.su || articleshowData.wu}
              title={articleshowData.hl}
              isWapView
              image={
                articleshowData.images ? articleshowData.images[0] : undefined
              }
              openSidebar={this.openSidebar}
              wu={articleshowData.wu}
              via={articleshowData.via}
              isTablet={false}
              hideSharingButtons
              hideSharingNative
              placeHolderStyles={{ minHeight: '24px' }}
              placeHolderLoaderClass="follow_us_loader"
              // wrapperClass="mobile-socialshare-top"
            />
          </div>

          {articleshowData.ismt && (
            <Mocktale {...articleshowData.advertorial} />
          )}

          {isHighlighPresent && (
            <Keyhighlights
              highlight={articleshowData.hlts}
              highlightCdata={articleshowData.hltsCdata}
            />
          )}
          {/* <WithGeo
            render={({ geoCountry, geoContinent }) => {
              const country =
                typeof geoCountry === 'string' ? geoCountry.toUpperCase() : '';
              const continent =
                typeof geoContinent === 'string'
                  ? geoContinent.toUpperCase()
                  : '';
              if (
                _get(
                  articleshowData,
                  `ads.dfp.slots.RosOut1x1.geoNew.exclude.continent`,
                  [],
                ).indexOf(continent) === -1 &&
                _get(
                  articleshowData,
                  `ads.dfp.slots.RosOut1x1.geoNew.exclude.country`,
                  [],
                ).indexOf(country) === -1
              ) {
                return !(
                  articleshowData.videos && articleshowData.videos.length > 0
                ) ? (
                  <AdCaller
                    data={{
                      ..._get(articleshowData, `ads.dfp.slots.RosOut1x1`, {}),
                      divId: `${
                        _get(articleshowData, `ads.dfp.slots.RosOut1x1`, {})
                          .divId
                      }-${msid}`,
                    }}
                    lazyload={false}
                    deviceType="all"
                    className={s.outstreamad}
                  />
                ) : null;
              }
              return null;
            }}
          /> */}
          <div id="affilaite_widget_carousel">
            {isMspArticle && !isHotPicks && this.getAffiliateWidgetCarousel()}
          </div>
          <div
            className={`${s.article_content} ${
              isMspArticle ? s.msp_wrapper : ''
            } ${
              this.isUnavailableArticle()
                ? getInactiveArticleClass({
                    reason: articleshowData.reason,
                  })
                : ''
            }`}
          >
            <div
              className={`${s.as_heading_wrapper} ${
                this.isUnavailableArticle() ? s.forceHide : ''
              }`}
            />

            <div
              className={`${s.articlebody}`}
              onMouseUp={e => this.selectText(e)}
            >
              <div
                data-articlebody="1"
                ref={myRef => {
                  this.articleBodyRef = myRef;
                }}
                className={`${`fewcent-${articleshowData.id}`} ${
                  this.props.blocked === 1 ? s.article_blocked : ''
                }`}
              >
                {qnaLayout && (
                  <>{this.renderFactsheetLayout(story, articleshowData)}</>
                )}
                {!qnaLayout &&
                  story &&
                  story.length &&
                  story.map((data, index) => (
                    <React.Fragment key={index}>
                      {this.getComponents(
                        data,
                        index,
                        articleshowData,
                        this.props.isMiniView,
                        dfp,
                        '',
                        '',
                        true,
                      )}

                      {/* uncomment next line to add affiliate widget after 4th br */}
                      {/* {this.brCount === 4 &&
                            this.totalBrCount >= 4 &&
                            this.getAffilateWidget()} */}
                      {index === 2 &&
                        isMspArticle &&
                        exitIntentPopup !== undefined &&
                        exitIntentPopup}
                    </React.Fragment>
                  ))}
                {/* {isAstrologyArticle && (
                  <div className="moreinfo">
                    <Links
                      target="_blank"
                      to="https://timesofindia.indiatimes.com/theopenmind-astroedition2023?utm_source=toi&utm_medium=astro_asbottomlink&utm_campaign=toi_astroevent "
                      doNotChangeURL
                    >
                      <span>
                        Learn about Astrology, Numerology and Tarot from
                        experts, sign up for The Open Mind Astro Summit 2023.
                      </span>
                    </Links>
                  </div>
                )} */}
                {getGeoCountry() === 'IN' && (
                  <AffiliatesContentV2
                    type="toi_widget_slots"
                    client="affiliates"
                    filters={{
                      pagename: 'articleshow',
                      slot: 'body_insert',
                      sectionl1,
                      keywords:
                        isReligionArticle || isAstrologyArticle
                          ? 'astro_talk'
                          : 'ros',
                    }}
                    componentProps={{
                      config: {
                        ga: {
                          label: this.props.msid,
                        },
                      },
                    }}
                  />
                )}
                {!(
                  ag === 'Mediawire' ||
                  ag === 'SPOTLIGHT' ||
                  ag === 'Brandwire' ||
                  isMspArticle
                ) && (
                  <AdCaller
                    className={s.mgid_bottom}
                    key={`mgid_bottom_${this.props.articleIndex}`}
                    skipReRender
                    msid={this.props.msid}
                    data={{
                      jname: 'mgid_bottom',
                      articleIndex: this.props.articleIndex,
                    }}
                  />
                )}

                {/* after sale we will remove this widget*/}
                {/* {!this.props.isUserPrime && this.getAffilateWidget()} */}

                {/* {!isMspArticle &&
                  !this.state.fullContentBlocked && (
                    <div className="coronaaswidget">
                      {this.getReadNextWidget()}
                    </div>
                  )} */}
                {this.state.showTwitterShareArticleContent && (
                  <div
                    className={s.shareInline}
                    onClick={() => this.shareSelectedText()}
                    style={{
                      top: `${this.state.shareOffsetTop}px`,
                      left: `${this.state.shareOffsetLeft}px`,
                    }}
                  >
                    <span
                      className={`${s.twitter} ${s.articlesprite} ${s.ishare}`}
                    >
                      <span className={s.inner}>Share to Twitter</span>
                    </span>
                  </div>
                )}
                {/* {articleshowData.videos &&
                  articleshowData.videos.length && (
                    <>
                      <Links
                        className={s.inline_vdolink}
                        to={articleshowData.videos[0].wu}
                        data-ga="BTF_watch_video|action|label"
                        data-setgacategory
                      >
                        <i>Watch</i>
                        <span> {articleshowData.videos[0].hl}</span>
                      </Links>
                    </>
                  )} */}
                {this.props.blocked === 1 &&
                  !this.props.isWapView && (
                    <LoginAccount
                      onClick={this.props.handleBlockerScreenLogin}
                      gaAction="Nonprime-login_blocker|CTA"
                      gaLabel={`${this.getSectionName()}_${getWebUrl(
                        this.props.articleData.wu,
                      )}`}
                    />
                  )}
                {/* {this.props.assignedTimesPoint ? (
                  <TimesPointPromoLoader
                    msid={this.props.msid}
                    assignedTimesPoint={this.props.assignedTimesPoint}
                  />
                ) : (
                  ''
                )} */}
                {/* {!frmapp && this.downloadTOIAppHtml(articleshowData)} */}
                {isWillowMetaPresent ? (
                  <WithGeo
                    render={({ geoCountry }) => {
                      const country =
                        typeof geoCountry === 'string'
                          ? geoCountry.toUpperCase()
                          : '';
                      if (country === 'US' && !isAdRemoved) {
                        //while making LIVE make this to US
                        return (
                          <div className={s.mobile_ads}>
                            <AdCaller
                              data={{
                                ..._get(
                                  articleshowData,
                                  `ads.dfp.slots.willowtv`,
                                  {},
                                ),
                                divId: `${
                                  _get(
                                    articleshowData,
                                    `ads.dfp.slots.willowtv`,
                                    {},
                                  ).divId
                                }-${msid}`,
                              }}
                              deviceType="all"
                            />
                          </div>
                        );
                      }
                      return null;
                    }}
                  />
                ) : (
                  ''
                )}

                {/**
                 * Commented this as per email subject: Re: Disclaimer in TNN copies
                 */}
                {/* {
                  articleshowData.metaInfo &&
                  articleshowData.metaInfo.AutoFeedIngestion === '1.0' &&
                  articleshowData.ag !== 'TNN' &&
                  articleshowData.ag !== 'Brandwire' &&
                  articleshowData.ag !== 'Mediawire' &&
                  articleshowData.ag !== 'Colombia' && (
                    <div className={s.disclaimer_lbl_mob}>
                      (This story has not been edited by timesofindia.com and is
                      auto–generated from a syndicated feed we subscribe to.)
                    </div>
                  )} */}
                {articleshowData.ag === 'Brandwire' &&
                articleshowData.advertorial &&
                articleshowData.advertorial.disclaimer ? (
                  <div
                    className={s.disclaimer_inbottom}
                    // eslint-disable-next-line react/no-danger
                  >
                    <h4>Disclaimer</h4>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: unescape(
                          articleshowData.advertorial.disclaimer,
                        ),
                      }}
                    />
                  </div>
                ) : null}
              </div>
              {isHotPicks && this.getAffiliateWidgetCarousel()}
              {mspBottomBanner}
              {subsecmsid2 &&
                subsecmsid2 === '107935854' && (
                  <div className={s.timesbetter_banner}>
                    <Links
                      target="_blank"
                      to="https://stockgro.onelink.me/vNON/40gk5zl2"
                      data={{
                        gaCategory: 'StockgroBanner',
                        gaAction: 'click',
                        gaLabel:
                          this.props &&
                          this.props.articleData &&
                          this.props.articleData.wu,
                      }}
                    >
                      <img
                        src="https://static.toiimg.com/photo/109056217.cms"
                        alt=""
                      />
                    </Links>
                  </div>
                )}
              {this.aboutAuthorWidget()}
              {/* {typeof amazonNsaAd === 'string' &&
                !this.props.perpetual && <AmazonNSA adCode={amazonNsaAd} />} */}
              {(!isArticleMini &&
                !this.isUnavailableArticle() &&
                !frmapp &&
                this.widgetPriorityMap &&
                this.widgetPriorityMap.comments === '') ||
              (this.widgetPriorityMap.comments &&
                Array.isArray(this.widgetPriorityMap.comments) &&
                (this.widgetPriorityMap.comments.length === 0 ||
                  this.widgetPriorityMap.comments.includes(articleIndex + 1) ||
                  (articleIndex + 1 >= 5 &&
                    this.widgetPriorityMap.comments.includes(1)))) ? (
                <ElementInView
                  gaLabel={
                    this.props.isEtimesArticle
                      ? 'top-comment_view'
                      : 'comments_view'
                  }
                >
                  <LoadableComponentLoader
                    loadInView
                    loadableComponentName="TopComment"
                    msid={articleshowData?.id}
                    href={articleshowData?.seo?.canonical}
                    onSidebarOpenClose={this.props.openSidebar}
                    commentsData={this.props.commentsData}
                    commentsCount={this.props.commentsCount}
                    isWapView={this.props.isWapView}
                    isTablet={this.props.isTablet}
                    isPrivateUser={this.props.isPrivateUser}
                    commentModeration={commentModerationVal}
                    // commentsAssignedTimesPoint={
                    //   this.props.commentsAssignedTimesPoint
                    // }
                    isEtimesArticle={this.props.isEtimesArticle}
                    gaCategory={categoryForGA}
                    gaAction={
                      this.props.isEtimesArticle ? 'BTF_comments' : 'click'
                    }
                    gaLabel={this.props.isEtimesArticle ? '' : 'Comments_click'}
                    placeHolderStyles={{ minHeight: '113px' }}
                  />
                </ElementInView>
              ) : null}
            </div>
            {isArticleMini && (
              <button
                className={s.showfullarticle}
                onClick={this.showFullArticle}
                type="button"
              >
                Show full article
              </button>
            )}

            {isArticleMini && !frmapp ? (
              <div className={s.minitopcomment}>
                <LoadableComponentLoader
                  loadInView
                  loadableComponentName="TopComment"
                  msid={articleshowData?.id}
                  href={articleshowData?.seo?.canonical}
                  onSidebarOpenClose={this.props.openSidebar}
                  commentsData={this.props.commentsData}
                  commentsCount={this.props.commentsCount}
                  isWapView={this.props.isWapView}
                  isTablet={this.props.isTablet}
                  isPrivateUser={this.props.isPrivateUser}
                  commentModeration={commentModerationVal}
                  // commentsAssignedTimesPoint={
                  //   this.props.commentsAssignedTimesPoint
                  // }
                />
              </div>
            ) : null}
            <div className={s.end_article}>
              <InViewObserver
                inViewCallback={() => {
                  if (!this.state.viewGA4summarizedstory) {
                    analyticsWrapper('ga4', {
                      event: 'story_complete',
                      type: 'articleshow',
                    });
                  }
                }}
              >
                <span>End of Article</span>
              </InViewObserver>
            </div>
            {isThisArticleAdActive &&
              this.props.articleIndex !== 1 && (
                <AdCaller
                  key={`mgid_with_tower${this.props.msid}`}
                  skipReRender
                  adWapperClass={s.mgid_with_tower}
                  data={{
                    name: 'mgid_with_tower',
                    articleIndex: this.props.articleIndex,
                  }}
                  msid={this.props.msid}
                />
              )}
            {!isMspArticle &&
              !this.state.fullContentBlocked &&
              articleshowData.ag !== 'SPOTLIGHT' &&
              !this.isEducationSection(articleshowData) && (
                <PersonaliseWidget
                  isWapView
                  card="readNextColumnVariant"
                  section={this.getSectionName() || ''}
                  subsection={_get(
                    this.props.articleData?.navsubsecs?.subsec2,
                    'subsecname2',
                    '',
                  )}
                  msid={this.props.msid}
                  template="AS"
                  contentprimestatus="non-prime"
                  userprimestatus={
                    this.props.isUserPrime ? 'prime' : 'non-prime'
                  }
                  styleObj={{ minHeight: '356px' }}
                  classname="readnextshimmer"
                />
              )}
            {!isMspArticle &&
              !this.isUnavailableArticle() && (
                <div className={`${s.tpSpacing}`}>
                  <span className={s.inlineshare_heading}>
                    FOLLOW US ON SOCIAL MEDIA
                  </span>
                  {this.props.isWapView &&
                    !this.props.isAppView && (
                      <ElementInView gaLabel="btfFollow_view">
                        <LoadableComponentLoader
                          loadInView
                          loadableComponentName="SocialSharingMobile"
                          textSize={this.state.textSize}
                          isWapView
                          hideSharingButtons
                          showFollowButtons
                          // textRequired
                          wrapperClass="mobile-socialshare-bottom"
                          gaCategory={categoryForGA}
                          gaAction={
                            this.props.isEtimesArticle
                              ? 'click-follow-us'
                              : 'click'
                          }
                          gaIndex={
                            this.props.isEtimesArticle ? '' : 'btfFollow_'
                          }
                          sectionName={sectionName.toLowerCase()}
                          isEtimes={this.props.isEtimesArticle}
                          placeHolderStyles={{ minHeight: '24px' }}
                          placeHolderLoaderClass="follow_us_loader"
                        />
                      </ElementInView>
                    )}
                </div>
              )}
            <React.Fragment>{this.getHouzzHtml()}</React.Fragment>
            <>
              {!isMspArticle &&
                !this.props.isEtimesArticle && (
                  <div className={s.btm_seo}>
                    <div className={s.h_title}>
                      <i />
                      <span>
                        {articleshowData &&
                        articleshowData.trendingBottomWidgetLinks
                          ? articleshowData.trendingBottomWidgetLinks
                              .widgetTitle
                          : 'In Focus'}
                      </span>
                    </div>
                    <LinksList
                      sectionData={articleshowData?.trendingBottomWidgetLinks}
                      cssSelector="astrendinglist"
                      gaCategory={
                        this.props.pageType === 'ARTICLESHOW' &&
                        this.props.categoryForGA
                          ? `${this.props.categoryForGA}`
                          : 'ATF_seo_links'
                      }
                      gaAction={
                        this.props.pageType === 'ARTICLESHOW' &&
                        this.props.categoryForGA
                          ? 'click'
                          : 'link_###index###'
                      }
                      gaLabel={
                        this.props.pageType === 'ARTICLESHOW' &&
                        this.props.categoryForGA
                          ? 'topSearches'
                          : ''
                      }
                    />
                  </div>
                )}
              {/* <div className={s.end_article}>
                <span>end of article</span>
              </div> */}

              {/* <div>
                <LoadableComponentLoader
                  loadOnScroll
                  loadableComponentName="BlockedNotificationCard"
                  isWap
                />
              </div> */}
              {isMspArticle && <div id="show_exit_intent" />}
              {/* {isCityArticle &&
                city &&
                Object.keys(pollutionData).length !== 0 &&
                pollutionData.aqi && (
                  <div
                    className="pollution"
                    // data-scrollga={`${categoryForGA}#scroll#pollution_widget_view`}
                  >
                    <LoadableComponentLoader
                      loadOnScroll
                      loadableComponentName="AirPollutionWidget"
                      city={city}
                      airData={pollutionData}
                    />
                  </div>
                )} */}
              {this.props.isEtimesArticle &&
                this.props.nextArticleData && (
                  <ElementInView gaLabel="read-next_view">
                    <LoadableComponentLoader
                      loadInView
                      loadableComponentName="NextArticlesBottomWidget"
                      data={this.props.nextArticleData}
                    />
                  </ElementInView>
                )}
              {isThisArticleAdActive && (
                <AdCaller
                  key={`mrecEndOfArticle${this.props.msid}`}
                  pauseAdCall={this.props.blocked !== -1}
                  skipReRender
                  adWapperClass={`${s.mobile_ads} ${
                    s.ad_end_of_article
                  } CLSPlaceholder dfp_ATF_wrapper `}
                  data={{
                    jname: 'bottom_mrec',
                  }}
                  className={s.mobile_ads_spacing}
                />
              )}
              {/* <React.Fragment>{this.getReadAlsoWidget()}</React.Fragment> */}
              <React.Fragment>
                {!this.props.perpetual && this.getTrendingStoriesWidget()}
              </React.Fragment>
              {/* <React.Fragment>
                {this.getReadAlsoInlineWidget('trendingstorycity')}
              </React.Fragment> */}

              {(this.widgetPriorityMap &&
                this.widgetPriorityMap.nativevs === '') ||
                (this.widgetPriorityMap.nativevs &&
                  Array.isArray(this.widgetPriorityMap.nativevs) &&
                  (this.widgetPriorityMap.nativevs.length === 0 ||
                    this.widgetPriorityMap.nativevs.includes(
                      articleIndex + 1,
                    ) ||
                    (articleIndex + 1 >= 5 &&
                      this.widgetPriorityMap.nativevs.includes(1))) &&
                  true && (
                    <>
                      {!this.props.perpetual &&
                        this.getVisualStories(subSecSeoLocation)}
                    </>
                  ))}

              {articleshowData?.calculatorData &&
                Array.isArray(articleshowData?.calculatorData) &&
                articleshowData?.calculatorData?.length > 0 && (
                  <CalculatorList
                    items={articleshowData?.calculatorData[0]?.items}
                    name={articleshowData?.calculatorData[0]?.tn}
                    isArticleshowPage
                    isWapView
                  />
                )}

              {/* <React.Fragment>{this.getTopVideosWidget()}</React.Fragment> */}

              {/* <React.Fragment>
                {this.getReadAlsoInlineWidget('trendingstoryentire')}
              </React.Fragment> */}
              {/* <ElementInView
                gaLabel={
                  this.props &&
                  this.props.articleData &&
                  this.props.articleData.wu
                }
                gaCategory="TimesBetterIndiaPromo"
                gaAction="seen"
              >
                <div className={s.timesbetter_banner} />
                <div className={s.timesbetter_banner}>
                  <Links
                    to="https://timesofabetterindia.com/big-picture-contest?utm_source=til&utm_medium=til&utm_campaign=toabi "
                    data={{
                      gaCategory: 'TimesBetterIndiaPromo',
                      gaAction: 'click',
                      gaLabel:
                        this.props &&
                        this.props.articleData &&
                        this.props.articleData.wu,
                    }}
                  >
                    <img
                      src="https://static.toiimg.com/photo/93291169.cms"
                      alt=""
                    />
                  </Links>
                </div>
              </ElementInView> */}

              {this.props.isEtimesArticle &&
                isEntertainmentArticle &&
                this.getEtimesFeaturedWidget(subSecSeoLocation)}

              {this.props.isEtimesArticle &&
                this.getVideosWidget(subSecSeoLocation)}

              {this.props.isEtimesArticle &&
                this.getPhotoStoriesWidget(subSecSeoLocation)}

              {this.props.isEtimesArticle &&
                !isEntertainmentArticle &&
                this.getEtimesFeaturedWidget(subSecSeoLocation)}

              {/* {!this.experimentBottom && (
                <div className={s.wdtbelowarticle}>
                  {!this.isUnavailableArticle() && this.getCoronaWidget()}
                </div>
              )} */}
            </>
            {/* {(this.widgetPriorityMap &&
              this.widgetPriorityMap.search &&
              this.widgetPriorityMap.search.games === '') ||
              (this.widgetPriorityMap.search &&
                this.widgetPriorityMap.search.games &&
                Array.isArray(this.widgetPriorityMap.search.games) &&
                (this.widgetPriorityMap.search.games.length === 0 ||
                  this.widgetPriorityMap.search.games.includes(
                    articleIndex + 1,
                  ) ||
                  (articleIndex + 1 >= 5 &&
                    this.widgetPriorityMap.search.games.includes(1))) &&
                !isMspArticle &&
                !this.props.isEtimesArticle &&
                !this.state.isSpotlightArticle && (
                  <div className={s.gamewrap}>{this.getGamesData()}</div>
                ))} */}
            {(this.widgetPriorityMap &&
              this.widgetPriorityMap.search &&
              this.widgetPriorityMap.search.search === '') ||
              (this.widgetPriorityMap.search &&
                this.widgetPriorityMap.search.search &&
                Array.isArray(this.widgetPriorityMap.search.search) &&
                (this.widgetPriorityMap.search.search.length === 0 ||
                  this.widgetPriorityMap.search.search.includes(
                    articleIndex + 1,
                  ) ||
                  (articleIndex + 1 >= 5 &&
                    this.widgetPriorityMap.search.search.includes(1))) &&
                !(
                  ag === 'Mediawire' ||
                  ag === 'SPOTLIGHT' ||
                  ag === 'Brandwire' ||
                  isMspArticle ||
                  this.props.isEtimesArticle
                ) && (
                  <LoadableComponentLoader
                    loadInView
                    loadableComponentName="MidArticleSearch"
                    updateMwebOpenSearchStatus={
                      this.props &&
                      typeof this.props.updateMwebOpenSearchStatus ===
                        'function'
                        ? this.props.updateMwebOpenSearchStatus
                        : undefined
                    }
                    isArticleshowPage
                  />
                ))}
            <div className={s.wdtbelowarticle}>
              {!this.isUnavailableArticle() && this.getMspPageWidgets()}
            </div>

            {/* add below condition to change position of affiliate widget */}
            {/* this.totalBrCount < 4 && */}
            {/* commenting this widget till sale period */}
            {!this.props.isUserPrime && this.getAffilateWidget()}
            {/* {(this.widgetPriorityMap &&
              this.widgetPriorityMap.affilates === '') ||
              (this.widgetPriorityMap.affilates &&
                (this.widgetPriorityMap.affilates.length === 0 ||
                  this.widgetPriorityMap.affilates.includes(articleIndex + 1) ||
                  (articleIndex + 1 >= 5 &&
                    this.widgetPriorityMap.affilates.includes(1))) &&
                !isMspArticle &&
                this.getAffilateWidget())} */}

            {/* <WithGeo
              render={({ geoCountry }) => {
                const country =
                  typeof geoCountry === 'string'
                    ? geoCountry.toUpperCase()
                    : '';
                if (country !== 'IN') {
                  return (
                    <div className={`${s.articlebody}`}>
                      {this.getAsBriefs()}
                    </div>
                  );
                }
                return null;
              }}
            /> */}

            <WithGeo
              render={({ geoCountry }) => {
                const country =
                  typeof geoCountry === 'string'
                    ? geoCountry.toUpperCase()
                    : '';
                if (country !== 'IN') {
                  return (
                    <div className={`${s.articlebody}`}>
                      {this.getOpinionPoll()}
                    </div>
                  );
                }
                return null;
              }}
            />

            {!isMspArticle &&
              !this.isUnavailableArticle() && (
                <React.Fragment>{this.renderTopStories()}</React.Fragment>
              )}
            <div />
            {!frmapp &&
              articleshowData.ag &&
              articleshowData.ag.toLowerCase() === 'brandwire' &&
              this.props.commentsData &&
              this.props.commentsData[0] &&
              this.props.commentsData[0].topComment && (
                <BrandwireComments
                  commentsData={this.props.commentsData[0].topComment}
                  isWapView={this.props.isWapView}
                />
              )}
            {!this.isUnavailableArticle() && (
              <div id={`comment-sidebar-${this.props.msid}`}>
                <WithCommentLoader
                  msid={this.props.msid}
                  isWapView={this.props.isWapView}
                  commentTextInputRef={this.commentTextInput}
                  seoData={articleshowData.seo}
                  commentModeration={commentModerationVal}
                />
              </div>
            )}

            {this.props.latestInfoGps ? (
              <InfoGraphicMobile nextLinks={this.props.latestInfoGps} />
            ) : null}
            <div data-articlepage-end={this.props.msid} />
          </div>
        </div>
        {this.state.onScrollScripts.size !== 0 && (
          <LoadableComponentLoader
            loadOnScroll
            loadableComponentName="ScriptLoader"
            scripts={this.state.onScrollScripts}
          />
        )}
        {isMspArticle && AffiliatePageIframe}
      </>
    );
  }
}

ArticleshowInner.propTypes = {
  isWapView: PropTypes.bool,
  msid: PropTypes.string.isRequired,
  isMiniView: PropTypes.bool,
  isAppView: PropTypes.bool,
  articleData: PropTypes.shape({}).isRequired,
  commentsCount: PropTypes.number.isRequired,
  commentsData: PropTypes.arrayOf(PropTypes.shape({})),
  openSidebar: PropTypes.func.isRequired,
  adsCampaignStatus: PropTypes.shape({}),
  isUserLoggedin: PropTypes.bool.isRequired,
  showLogin: PropTypes.func.isRequired,
  isUserPrime: PropTypes.bool,
  isTablet: PropTypes.func.isRequired,
  loadVideoTheatreSlider: PropTypes.func.isRequired,
  query: PropTypes.shape({}),
  videoTheatreSliderData: PropTypes.arrayOf({}),
  addNextVideoMsid: PropTypes.func.isRequired,
  isPrivateUser: PropTypes.bool,
  perpetual: PropTypes.bool,
  // exitPollData: PropTypes.shape({}).isRequired,
  // electionsData: PropTypes.shape({}).isRequired,
  currentCountry: PropTypes.string,
  blocked: PropTypes.number,
  handleBlockerScreenLogin: PropTypes.func,
  commonData: PropTypes.shape({}),
  headerCrownPoints: PropTypes.bool,
  // assignedTimesPoint: PropTypes.number,
  ExternalClass: PropTypes.string,
  cssObject: PropTypes.shape({}),
  electionFlag: PropTypes.bool,
  categoryForGA: PropTypes.string,
  sectionName: PropTypes.string,
  articleIndex: PropTypes.number,
  removeAffiliateWidget: PropTypes.bool,
  isMspArticle: PropTypes.bool,
  isMspUSPage: PropTypes.bool,
  city: PropTypes.string,
  // pollutionData: PropTypes.shape({}),
  abAdskey: PropTypes.string,
  abTestExperimentId: PropTypes.shape({}),
  pgWidgetData: PropTypes.shape({}),
  widgetPriorityMap: PropTypes.shape({}),
  preloadedLeadImageHref: PropTypes.string,
  isAdRemoved: PropTypes.bool,
  isEtimesArticle: PropTypes.bool,
  nextArticleData: PropTypes.shape({}),
  stickyContentSupport: PropTypes.bool,
  spotlightSpecificAds: PropTypes.bool,
  isAutoPublishedArticle: PropTypes.bool,
  isSportsBeaconJs: PropTypes.bool,
};

ArticleshowInner.defaultProps = {
  isWapView: false,
  isMiniView: false,
  isAppView: false,
  commentsData: [],
  adsCampaignStatus: undefined,
  isUserPrime: false,
  query: {},
  videoTheatreSliderData: undefined,
  isPrivateUser: true,
  perpetual: false,
  currentCountry: '',
  blocked: 0,
  handleBlockerScreenLogin: () => {},
  commonData: undefined,
  headerCrownPoints: false,
  // assignedTimesPoint: 0,
  ExternalClass: '',
  cssObject: {},
  electionFlag: false,
  categoryForGA: '',
  sectionName: '',
  articleIndex: 0,
  removeAffiliateWidget: false,
  isMspArticle: false,
  isMspUSPage: false,
  city: '',
  // pollutionData: {},
  abAdskey: '',
  abTestExperimentId: {},
  pgWidgetData: {},
  widgetPriorityMap: {},
  preloadedLeadImageHref: '',
  isAdRemoved: false,
  isEtimesArticle: false,
  nextArticleData: undefined,
  stickyContentSupport: false,
  spotlightSpecificAds: false,
  isAutoPublishedArticle: false,
  isSportsBeaconJs: false,
};

const mapStateToProps = state => ({
  // isShowSearchOverlay: _get(state, 'articleshow_v2.isShowSearchOverlay', false),
  isOrganic: state.articleshow_v2.isOrganic,
  isPaidTraffic: state.articleshow_v2.isPaidTraffic,
  electionTabs: state.common?.siteConfig?.electionTabs,

  // cardsData: _get(state, 'readnextbundle.readNextCards', {}),
  // personalizeWidgetData: _get(state, 'personalizeData.widgetData', {}),
  isPowerByAdActive: _get(
    state,
    'common.siteConfig.revenue.electionPowerby.isAdActive',
    0,
  ),
});

const mapDispatchToProps = dispatch => ({
  updateSearchOverlayStatus: params => {
    dispatch(updateSearchOverlayStatus(params));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(ArticleshowInner);
